// Angular
import { Component, ViewChild, LOCALE_ID, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";

// Material design
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Grid
import { setCulture, Internationalization, extend } from '@syncfusion/ej2-base';
import {
  EditSettingsModel, Column, ForeignKeyService, PageService, ColumnChooserService,
  ToolbarService, SortService, GroupService, ResizeService, ReorderService, AggregateService,
  ColumnMenuService, ContextMenuService, GroupSettingsModel, GridComponent, ExcelExportService, PdfExportService, ContextMenuItemModel,
  ExcelExportProperties, ContextMenuClickEventArgs, CommandModel, DetailRowService, ToolbarItems, IEditCell, ContextMenuOpenEventArgs, FilterService, EditService,
  CustomSummaryType, AggregateColumnModel, RowInfo,
  parentsUntil
} from '@syncfusion/ej2-angular-grids';
import { DataManager, WebApiAdaptor, Query, Predicate } from '@syncfusion/ej2-data';
import { FilteringEventArgs, ChangeEventArgs, DropDownList, ComboBox } from '@syncfusion/ej2-angular-dropdowns';
import { SplitterComponent } from '@syncfusion/ej2-angular-layouts';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { NumericTextBox } from '@syncfusion/ej2-angular-inputs';

// WebApi
import {
  VoucherViewClient,
  VoucherMessageViewClient,
  VoucherUtilClient as UtilClient,
  VoucherMessageViewDetailsClient as DetailsClient,
  VoucherMessageViewDetailsVm as DetailsVm,
  VoucherPostingViewDto as PostingViewDto,
  VoucherMessageViewDto as MessageViewDto,
  VoucherApprovalStatusDto as ApprovalStatusDto,
  VoucherApprovalStatusEnum,
  UserDto,
  VendorViewDto,
  VoucherBaseDataClient,
  VoucherBaseDataVm,
  CurrencyDto,
  VoucherPostingTypeDto,
  ProjectDto,
  ProjectCostTypeDto,
  VoucherPostingTypeEnum,
  FinanceLedgerAccountDto,
  VoucherMessageStatusEnum,
  DebtorDto,
  BankAccountDto,
  Finance_TaxCode,
  VoucherViewDto,
  LinkedAttachmentDto,
  VoucherViewResponse,
  UserApprovalDelegationDto
} from 'src/app/api';

//import { LookupTable, RecordSelectedEventArg } from './commerce-voucher-basedata.component';
import { VoucherHelper, VoucherService } from '../voucher.service';
import { CerAppChatService } from '../../../cer-app/cer-app-chat/cer-app-chat.service';
import { CerAppFileViewerTabComponent, TabSelectedApplyData, ViewCommandEvent } from 'src/cer-app/cer-app-file-viewer-tab/cer-app-file-viewer-tab.component';
import { CerDropDownList } from 'src/cer/cer-control/cer-drop-down-list/cer-drop-down-list';
import { CerLocaleService } from '@ui/cer-ui-locale.service';
import { CerEditDatePickerAdapter } from 'src/cer/cer-control/cer-date-edit/cer-edit-cell-date-picker-adapter';
import { VoucherDataService } from '../voucher-data.service';
import { VoucherAttachmentService } from '../voucher-attachment.service';
import { CerPromptService, PromptInput } from '@ui/cer-ui-prompt.service';
import { CerAppStateService, DataTableCache } from 'src/cer-app/cer-app-state/cer-app-state.service';
import { uiCmdPaneRightToggle } from '@form/cer-form-panes/cer-form-panes.service';
import { ForfatterComponent } from 'src/app/contract/forfatter/forfatter.component';

import { CerGridCommandService } from '@cer/cer-grid/cer-grid-command.service';

enum GridNavigationCmd {
  None,
  Default,
  Voucher,
  Posting,
  PostingFirst,
  PostingLast
};

type ActionType = 'ApprovedAndClose' | 'PendingApprovalAndClose' | 'OnHoldAndClose' | 'NewApproverAndClose' | 'SaveAndClose' | 'Close' | 'AdjustAmounts' | 'Error';

@Component({
  selector: 'voucher-detail',
  templateUrl: './voucher-detail.component.html',
  styleUrls: ['./voucher-detail.component.css'],
  providers: [VoucherService, PageService, EditService, ForeignKeyService, FilterService, SortService, GroupService, ResizeService, ReorderService,
    ToolbarService, ColumnChooserService, ColumnMenuService, ContextMenuService,
    ExcelExportService, PdfExportService, DetailRowService, AggregateService]
  //    : ChangeDetectionStrategy.OnPush // ChangeDetectionStrategy.Default
})

export class VoucherDetailComponent implements OnInit, OnDestroy {
  // State
  protected pageIsLoading: boolean = true;
  protected isExpenseVoucher: boolean = false;
  protected isProformaEditFromInbox: boolean = false;
  protected attachmentsIsActive: boolean = false;
  protected isAnyVoucherPosted: boolean = false;
  protected isStatusColumnVisible: boolean = false;
  protected categoryVisible: boolean = false;
  protected canEdit: boolean = true;
  protected canNewApprover: boolean = false;
  protected canSendToPending: boolean = false;

  private voucherGridIsDataBound: boolean = false;
  private postingGridIsDataBound: boolean = false;
  private gridNavigationCmd: GridNavigationCmd = GridNavigationCmd.Default;
  private gridCancelledConfirmed: GridComponent = null;
  //private dialogObj: Dialog = null;

  // Form dialog
  protected showChat: boolean = false;
  private callerMsgId: number = null;
  protected voucherCanSaveAndClose: boolean = true;

  private splitterObj: SplitterComponent;
args: any;
  @ViewChild('splitterInstance', { static: false }) set splitterContent(splitterObj: SplitterComponent) {
    if (splitterObj && !this.splitterObj) {
      this.splitterObj = splitterObj;
      if (this.attachmentsIsActive) {
        this.splitterObj.paneSettings[1].collapsed = false;
      }
    }
  }

  // File viewer
  private tabAttachments: CerAppFileViewerTabComponent;
  @ViewChild('tabAttachments', { static: false }) set setFileViewerTab(tab: CerAppFileViewerTabComponent) {
    if (tab && !this.tabAttachments) {
      this.tabAttachments = tab;
    }
  }
  // WebApi
  //public data: DataManager = null;
  private messageDto: MessageViewDto = null;
  protected voucherDtoList: VoucherViewDto[] = null;
  private voucherDtoActive: VoucherViewDto = null;
  protected postingDtoListAll: PostingViewDto[] = null;
  protected postingDtoList: PostingViewDto[] = null;
  protected approvalStatusDto: ApprovalStatusDto[] = null;
  private detailsVmMap = new Map<number, DetailsVm>();
  protected detailsVm: DetailsVm = null;
  private voucherBaseDataLoaded: boolean = false;
  private usersAll: UserDto[] = null;
  private users: UserDto[] = null;
  protected usersDM: DataManager;
  private userCurrent: UserDto = null;
  private userApprovalDelegations: UserApprovalDelegationDto[] = null;
  private taxCodes: Finance_TaxCode[] = null;
  protected taxCodesDM: DataManager;
  protected ledgerDimensionsDM: DataManager;
  private currencies: CurrencyDto[] = null;
  protected currenciesDM: DataManager;
  private postingTypes: VoucherPostingTypeDto[] = null;
  protected postingTypesDM: DataManager;
  private vendorsDefault: VendorViewDto[] = null;
  private debtorsDefault: DebtorDto[] = null;
  private projectsDefault: ProjectDto[] = null;
  private projectLedgerAccounts: FinanceLedgerAccountDto[] = null;
  private ledgerAccounts: FinanceLedgerAccountDto[] = null;
  protected ledgerAccountsDM: DataManager;
  private projectCostTypes: ProjectCostTypeDto[] = null;
  protected projectCostTypesDM: DataManager;
  private projectCostTypesFiltered: ProjectCostTypeDto[] = null;
  protected projectCostTypesFilteredDM: DataManager;
  private bankAccounts: BankAccountDto[] = null;
  protected userIsAdmin: boolean = false;
  protected dataIsReady: boolean = false;
  protected fromName: string = null;

  private voucherSkipCancelDialog: boolean = false;
  protected voucherIsStatusCreated: boolean = false;
  protected voucherCanApprove: boolean = false;
  protected voucherCanApproveByPostingEdit: boolean = false;
  protected voucherCanHold: boolean = false;
   private voucherCheckUniqueOnLoad: boolean = false;

  private postingDtoEdit: PostingViewDto = null;
  private postingAmountCurEditValue: number = null;

  private vendorPostingProformaDtoOrg: PostingViewDto = null;
  private projectPostingProformaDtoOrg: PostingViewDto = null;

  // Grid options
  // Formatting
  protected dateFormat: any = { type: "date", format: "dd.MM.yyyy" };
  protected dateTimeFormat: any = { type: "date", format: "dd.MM.yyyy HH:mm" };

  // Message grid
  private messageGrid: GridComponent;
  @ViewChild('messageGrid', { static: false }) set messageGridContent(content: GridComponent) {
    if (content && !this.messageGrid) {
      this.messageGrid = content;
    }
  }
  protected messageGridContextMenuItems: ContextMenuItemModel[] = [
    { id: 'gridColumnHide', text: "Skjul kolonne", iconCss: "e-menu-icon e-icons .e-icon-hide", target: ".e-headercontent" },
    { id: 'gridColumnsChoose', text: "Kolonner ..", iconCss: ".e-grid-menu e-icons .e-columnchooserdiv", target: ".e-headercontent" }
  ];


  // Voucher grid
  private voucherGrid: GridComponent;
  @ViewChild('voucherGrid', { static: false }) set voucherGridContent(content: GridComponent) {
    if (content && !this.voucherGrid) {
      this.voucherGrid = content;
      this.gridEditRowOnClickSetup(this.voucherGrid);
      var transDateCol: Column = this.voucherGrid.getColumnByField('transDate');
      new CerEditDatePickerAdapter(this.voucherGrid, transDateCol, this.localeService);
      var documentDateCol: Column = this.voucherGrid.getColumnByField('documentDate');
      new CerEditDatePickerAdapter(this.voucherGrid, documentDateCol, this.localeService);
    }
  }
  private voucherClickTarget: Column;
  protected voucherGridToolbar: ToolbarItems[] | object = [
    { text: 'Vedhæftninger', tooltipText: 'Vis/skjul vedhæftninger (ALT+V)', id: 'attachmentsShowHide', prefixIcon: uiCmdPaneRightToggle.iconCss, align: 'Right' },
    'Edit',
    'Update',
    'Cancel'
  ];
  protected voucherGridGroupSettings: GroupSettingsModel = { disablePageWiseAggregates: true, showDropArea: false, showUngroupButton: true, showGroupedColumn: false };
  protected gridCommands: CommandModel[] = [
    { type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
    { type: 'Delete', buttonOption: { cssClass: 'e-flat', iconCss: 'e-delete e-icons' } },
    { type: 'Save', buttonOption: { cssClass: 'e-flat', iconCss: 'e-update e-icons' } },
    { type: 'Cancel', buttonOption: { cssClass: 'e-flat', iconCss: 'e-cancel-icon e-icons' } }];
  protected voucherGridEditSettings: EditSettingsModel = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal', showDeleteConfirmDialog: true, newRowPosition: 'Bottom' };
  protected voucherGridContextMenuItems: ContextMenuItemModel[] = [
    { id: 'gridColumnGroup', text: "Grupper", iconCss: "e-menu-icon e-icons e-icon-group", target: ".e-headercontent" },
    { id: 'gridColumnHide', text: "Skjul kolonne", iconCss: "e-menu-icon e-icons e-icon-hide", target: ".e-headercontent" },
    { id: 'gridColumnsChoose', text: "Kolonner ..", iconCss: "e-grid-menu e-icons e-columnchooserdiv", target: ".e-headercontent" },
    { separator: true, target: ".e-headercontent" },
    { id: 'gridExcelExport', text: "Excel eksport", iconCss: "e-menu-icon e-icons e-excelexport", target: ".e-headercontent" },
    { separator: true, target: ".e-headercontent" },
    { id: 'dataBind', text: "Genlæs data", iconCss: "e-menu-icon e-icons e-reload-01", target: ".e-headercontent" },
    { id: 'setStatusPending', text: "Sæt status 'Til godkendelse'", iconCss: "e-menu-icon e-icons e-document-01", target: ".e-content" },
    { id: 'setStatusOnHold', text: "Sæt status 'Afventer'", iconCss: "e-menu-icon e-icons e-document-01", target: ".e-content" },
    { id: 'setStatusApproved', text: "Sæt status 'Godkendt'", iconCss: "e-menu-icon e-icons e-document-01", target: ".e-content" },
    { id: 'setStatusAccounted', text: "Sæt status 'Afsluttet'", iconCss: "e-menu-icon e-icons e-close-01", target: ".e-content" },
    { id: 'setStatusPosted', text: "Sæt status 'Bogført'", iconCss: "e-menu-icon e-icons e-document-01", target: ".e-content" }];

  // Posting grid
  private postingGrid: GridComponent;
  @ViewChild('postingGrid', { static: false }) set postingGridContent(content: GridComponent) {
    if (content && !this.postingGrid) {
      this.postingGrid = content;
    }
  }
  private postingClickTarget: Column;
  protected postingGridEditSettings: EditSettingsModel = {
    allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal', showConfirmDialog: false,
    showDeleteConfirmDialog: true, newRowPosition: 'Bottom'
  };
  protected postingGridGroupSettings: GroupSettingsModel = {/* disablePageWiseAggregates: true,*/ showDropArea: false, showUngroupButton: true, showGroupedColumn: false };
  protected postingGridToolbar: ToolbarItems[] | object = [
    { text: 'Fordel beløb', tooltipText: 'Fordel beløb konteret til at matche fakturabeløb', id: 'postingAdjustAmounts' },
    'Edit',
    'Update',
    'Cancel',
    { text: 'Ny post', id: 'postingAdd', prefixIcon: 'e-btn-icon e-add e-icons' },
    { text: 'Slet', id: 'postingDelete', prefixIcon: 'e-btn-icon e-delete e-icons' }
  ];
  protected postingGridContextMenuItems: ContextMenuItemModel[] = [
    { id: 'gridColumnGroup', text: "Grupper", iconCss: "e-menu-icon e-icons e-icon-group", target: ".e-headercontent" },
    { id: 'gridColumnUnGroup', text: "Fjern grupper", iconCss: "e-menu-icon e-icons e-icon-group", target: ".e-headercontent" },
    { id: 'gridColumnHide', text: "Skjul kolonne", iconCss: "e-menu-icon e-icons e-icon-hide", target: ".e-headercontent" },
    { id: 'gridColumnsChoose', text: "Kolonner ..", iconCss: "e-grid-menu e-icons e-columnchooserdiv", target: ".e-headercontent" },
    { separator: true, target: ".e-headercontent" },
    { id: 'gridExcelExport', text: "Excel eksport", iconCss: "e-menu-icon e-icons e-excelexport", target: ".e-headercontent" }
  ];

  // Controls
  private balanceAccountNumElement: HTMLInputElement;
  private documentNumElement: HTMLInputElement;

  protected voucherVendorAccountNumEditCell: IEditCell;
  private voucherVendorAccountNumDdl: CerDropDownList;
  private voucherVendorAccountNumDdlElement: HTMLInputElement;

  protected voucherProjectNumEditCell: IEditCell;
  private voucherProjectNumDdl: CerDropDownList;
  private voucherProjectNumDdlElement: HTMLInputElement;

  protected currencyEditCell: IEditCell;
  private currencyDdl: CerDropDownList;
  private currencyDdlElement: HTMLInputElement;

  protected approverEditCell: IEditCell;
  private approverDdl: CerDropDownList;
  private approverDdlElement: HTMLInputElement;

  protected postingTypeEditCell: IEditCell;
  private postingTypeDdl: CerDropDownList;
  private postingTypeDdlElement: HTMLInputElement;

  protected accountNumEditCell: IEditCell;
  private accountNumDdl: CerDropDownList;
  private accountNumDdlElement: HTMLInputElement;
  private accountNumEditDdlCurrentTableName: string = '';
  private accountNumFilterDefaultListData: object[] = null;

  private projectCostTypeDdl: CerDropDownList;
  public projectCostTypeEditCell: IEditCell;
  private projectCostTypeDdlElement: HTMLInputElement;

  private projectLedgerNumDdl: CerDropDownList;
  public projectLedgerNumEditCell: IEditCell;
  private projectLedgerNumDdlElement: HTMLInputElement;

  private taxCodeDdl: CerDropDownList;
  public taxCodeEditCell: IEditCell;
  private taxCodeDdlElement: HTMLInputElement;

  private ledgerDimensionDdl: CerDropDownList;
  public ledgerDimensionEditCell: IEditCell;
  private ledgerDimensionDdlElement: HTMLInputElement;

  public avoidFocusOnVendor: boolean = false;

  protected keyDownEventListener = this.handleKeyDownEvent.bind(this);;

  // inject the Element
  // Constructor
  constructor(private stateService: CerAppStateService,
    private client: VoucherViewClient, private messageClient: VoucherMessageViewClient, private detailsClient: DetailsClient, private voucherBaseDataClient: VoucherBaseDataClient,
    private utilClient: UtilClient,
    private router: Router, private chatService: CerAppChatService,
    private ui: CerPromptService,
    private localeService: CerLocaleService,
    private dialogRef: MatDialogRef<VoucherDetailComponent>,
    public sanitizer: DomSanitizer,
    private voucherService: VoucherService,
    //private voucherDataService: VoucherDataService,
    @Inject(MAT_DIALOG_DATA) callerData: any,
    @Inject(LOCALE_ID) locale: string) {

    setCulture(locale);

    if (callerData != null) {
      this.voucherCheckUniqueOnLoad = (callerData.voucherCheckUniqueOnLoad === true);
      this.callerMsgId = callerData.dto.msgId ? callerData.dto.msgId : callerData.dto.id; // Called from 1) voucher or 2) message
      this.userIsAdmin = callerData.userIsAdmin;
      this.attachmentsIsActive = (callerData.attachmentsIsActive || callerData.showChat);
      this.showChat = callerData.showChat;
      this.avoidFocusOnVendor = this.attachmentsIsActive;
    }

    if (!this.userIsAdmin) {
      this.voucherGridContextMenuItems = this.voucherGridContextMenuItems.filter(mi => !['setStatusApproved', 'setStatusAccounted', 'setStatusPosted'].includes(mi.id));
    }

  }

  ngOnInit(): void {
    this.chatService.chats$.subscribe(chat => {
      VoucherDataService.detailsVmMapRefreshChat(this.detailsVmMap, this.chatService, chat);
      this.dataBindCalcStatus();
    });

    if (this.callerMsgId != null) {
      this.detailsVmDataBind(true);
      this.voucherBaseDataVmDataBind();
    }

    document.addEventListener('keydown', this.keyDownEventListener, false);
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.keyDownEventListener, false);
  }


  private authToken: string;
  private apiDataManager(): DataManager {
    return new DataManager({
      url: '/api',
      adaptor: new WebApiAdaptor,
      headers: [{ Authorization: 'Bearer ' + this.authToken }]
    });
  }
  /*
  private pageIsLoadingUpdate() {
    this.pageIsLoading = (this.messageDtoList == null);
  }
  */

  // Router
  private routerShortUrl(): string {
    let routeShortUrl = this.router.url;
    while (routeShortUrl.startsWith('/')) {
      routeShortUrl = routeShortUrl.substr(1);
    }
    return routeShortUrl;
  }

  private voucherBaseDataTableName: string = 'VoucherBaseData';

  private async voucherBaseDataVmDataBind() {
    var cachedVm: DataTableCache = this.stateService.getDataTableCache(this.voucherBaseDataTableName);
    if (cachedVm.loaded) {
      this.baseDataVmUnpack(<VoucherBaseDataVm>cachedVm.data[0]);
    }
    else {
      this.voucherBaseDataClient.get().subscribe({
        next: (voucherBaseDataVm: VoucherBaseDataVm) => {
          this.baseDataVmUnpack(voucherBaseDataVm);
          this.stateService.setDataTableCache(cachedVm, [voucherBaseDataVm]);
        },
        error: (error: string) => {
          this.error(["Indlæsning af godkendelse fejlet", error]);
        }
      });
    }
  }

  private baseDataVmUnpack(baseDataVm: VoucherBaseDataVm) {
    this.usersAll = baseDataVm.usersAll;
    this.users = baseDataVm.users.filter(u => u.active);
    this.usersDM = new DataManager(this.users);
    this.userCurrent = baseDataVm.userCurrent;
    this.userApprovalDelegations = baseDataVm.userApprovalDelegations;
    this.taxCodes = baseDataVm.taxCodes;
    this.taxCodesDM = new DataManager(this.taxCodes);
    this.ledgerDimensionsDM = new DataManager(baseDataVm.ledgerDimensions);
    this.currencies = baseDataVm.currencies;
    this.currenciesDM = new DataManager(this.currencies)
    this.postingTypes = baseDataVm.postingTypes;
    this.postingTypesDM = new DataManager(this.postingTypes);

    this.vendorsDefault = baseDataVm.vendorsDefault;
    this.debtorsDefault = baseDataVm.debtorsDefault;
    this.projectsDefault = baseDataVm.projectsDefault;
    this.projectLedgerAccounts = baseDataVm.projectLedgerAccounts;
    this.ledgerAccounts = baseDataVm.ledgerAccounts;
    this.ledgerAccountsDM = new DataManager(this.ledgerAccounts);
    this.bankAccounts = baseDataVm.bankAccounts;
    this.bankAccounts.forEach(b => b.description = b.description ?? b.bankAccountNum);
    this.projectCostTypes = baseDataVm.projectCostTypes;
    this.projectCostTypes.push(new ProjectCostTypeDto({ id: null, num: '', name: '', description: '', costOnly: true }));
    this.projectCostTypesDM = new DataManager(this.projectCostTypes);
    this.voucherBaseDataLoaded = true;

    if (this.voucherBaseDataLoaded && this.detailsVm) {
      this.setAttachmentSelectextIdxDefault();
      this.dataBindGrids();
    }
  }

  // DetailsVm (including attachments etc)
  private detailsVmReBind(detailsVmNew: DetailsVm, focusVoucherId: number) {
    if (detailsVmNew != null) {
      this.detailsVm = detailsVmNew;
      this.detailsVmMap.set(this.detailsVm.voucherMessageViewDto.id, this.detailsVm);
      this.dataBindGrids();
      this.voucherGridRefreshSavedData();
      console.log('detailsVmReBind completed');
    }
  }

  private voucherGridRefreshSavedData() {
    this.voucherGrid.dataSource = this.voucherDtoList;
    this.postingGrid.dataSource = this.postingDtoList;
    this.postingGrid.refresh();
    this.actionRunDeferred();
  }

  protected attachmentIdxDefault: number = 0;

  private setAttachmentSelectextIdxDefault() {
    var idx: number = 0;
    var i: number = 0;
    if (this.showChat) {
      this.attachmentIdxDefault = this.detailsVm.voucherMessageAttachmentDtoList.length ?? 0;
      this.chatService.chatMarkRead(1, this.detailsVm.voucherMessageViewDto.id);
    }
    else {
      this.detailsVm.voucherMessageAttachmentDtoList.forEach(a => { if (idx == 0 && a.fileExtension.toLocaleLowerCase() == '.pdf') { idx = i }; i++; });
      this.attachmentIdxDefault = idx;
    }
  }

  private detailsVmDataBind(initialLoad: boolean = false) {
    this.voucherGridIsDataBound = false;
    this.postingGridIsDataBound = false;
    var msgId: number = this.callerMsgId;
    if (msgId) {
      if (this.detailsVmMap.has(msgId)) {
        this.detailsVm = this.detailsVmMap.get(msgId);
        if (initialLoad) {
          this.detailsVmDataBindOnInitialLoad();
        }
        this.dataBindGrids();
      }
      else {
        this.detailsVmGetPromise(msgId).then((detailsVm) => {
          if (initialLoad) {
            this.detailsVmDataBindOnInitialLoad();
          }
        });
      }
    }
  }

  private detailsVmDataBindOnInitialLoad() {
    this.setAttachmentSelectextIdxDefault();
    var voucherDto: VoucherViewDto = this.voucherDtoList?.length > 0 ? this.voucherDtoList[0] : null;
    if (voucherDto && this.voucherCheckUniqueOnLoad) {
      this.checkDocumentNumUniqueByVoucher(voucherDto);
    }
  }

  private detailsVmGet(msgId: number) {
    this.detailsVmGetPromise(msgId).then();
  }

  private detailsVmGetPromise(msgId: number, focusVoucherId: number = null): Promise<DetailsVm> {
    return new Promise<DetailsVm>((resolve) => {
      this.apiDetailsVmGet(msgId).then((detailsVm) => {
        this.detailsVmBindNonCached(msgId, detailsVm, focusVoucherId);
        resolve(detailsVm);
      });
    });
  }

  private apiDetailsVmGet(msgId: number): Promise<DetailsVm> {
    return new Promise<DetailsVm>((resolve, reject) => {
      this.detailsClient.get(msgId).subscribe({
        next: (detailsVm) => { resolve(detailsVm); },
        error: (error) => {
          this.ui.infoToast("Indlæsning af stamdata fejlet : " + error);
          reject(error);
        }
      });
    });
  }

  private detailsVmBindNonCached(msgId: number, detailsVm: DetailsVm, focusVoucherId: number = null) {
    this.voucherService.prepareDetailsVm(detailsVm);
    this.detailsVm = detailsVm;
    this.detailsVmMap.set(msgId, this.detailsVm);
    if (this.detailsVm && this.voucherBaseDataLoaded) {
      this.dataBindGrids();
    }
  }

  protected attachments: LinkedAttachmentDto[] = null;
  public dataBindGrids() {
    if (this.detailsVm && this.voucherBaseDataLoaded) {
      if (!this.isEqual(this.attachments, this.detailsVm.voucherMessageAttachmentDtoList)) {
        this.attachments = this.detailsVm.voucherMessageAttachmentDtoList;
      }
      this.dataIsReady = true;
      this.isExpenseVoucher = this.voucherService.isExpenseVoucher(this.detailsVm.voucherMessageChannelType);

      this.voucherDtoList = this.detailsVm.voucherViewDtoList;
      this.postingDtoListAll = this.detailsVm.voucherPostingViewDtoList;
      this.projectsDefault = this.projectsDefault;

      var voucherDto: VoucherViewDto = this.voucherDtoList.length > 0 ? this.voucherDtoList[0] : null;
      this.messageDto = this.detailsVm.voucherMessageViewDto;
      this.isProformaEditFromInbox = this.voucherService.isVendorVoucher(this.detailsVm.voucherMessageChannelType) && this.messageDto?.status == VoucherMessageStatusEnum.Inbox;

      this.canNewApprover = (!this.userIsAdmin && [VoucherApprovalStatusEnum.Pending, VoucherApprovalStatusEnum.OnHold].includes(voucherDto?.status));
      this.canSendToPending = (this.userIsAdmin && [VoucherApprovalStatusEnum.Created, VoucherMessageStatusEnum.Inbox].includes(voucherDto?.status));
      this.voucherCanSaveAndClose = true;
      if (this.canSendToPending && this.voucherService.isVendorVoucher(this.detailsVm.voucherMessageChannelType)) {
        this.voucherCanSaveAndClose = false;
      }

      if (!this.projectCostTypesFiltered) {
        this.projectCostTypesFiltered = this.isExpenseVoucher ? this.projectCostTypes : this.projectCostTypes.filter(c => c.costOnly);
        this.projectCostTypesFilteredDM = new DataManager(this.projectCostTypesFiltered);
      }

      //this.postingDtoListAll = Object.assign({}, this.detailsVm.voucherPostingViewDtoList);
      if (!this.userIsAdmin) {
        var that = this;
        this.postingDtoList = this.detailsVm.voucherPostingViewDtoList.filter(p => !that.isPostingTypeVendor(p.postingType))
      }
      else {
        this.postingDtoList = this.detailsVm.voucherPostingViewDtoList;
      }

      this.dataBindCalcStatus();

      this.vendorsDefault = this.vendorsDefault;
      this.detailsVm.vendorsSelected.forEach(s => {
        if (!this.vendorsDefault.find(d => d.num == s.num)) {
          this.vendorsDefault.unshift(s);
        }
      });

      this.categoryVisible = (this.isExpenseVoucher);

      this.debtorsDefault = this.debtorsDefault;
      this.detailsVm.debtorsSelected.forEach(s => {
        if (!this.debtorsDefault.find(d => d.num == s.num)) {
          this.debtorsDefault.unshift(s);
        }
      });

      this.projectsDefault = this.projectsDefault;
      this.detailsVm.projectsSelected.forEach(s => {
        if (!this.projectsDefault.find(d => d.num == s.num)) {
          this.projectsDefault.unshift(s);
        }
      });

      this.voucherVendorAccountNumEditCellSetup(); // Voucer vendor account num
      this.voucherProjectNumEditCellSetup();  // Voucher project num
      this.currencyEditCellSetup(); // Currency
      this.approverEditCellSetup();  // User (approver)
      this.postingTypeEditCellSetup();  // Posting type editor
      this.accountNumEditCellSetup();   // Account num editor
      this.projectCostTypeEditCellSetup(); // Cost type editor
      this.projectLedgerNumEditCellSetup(); // Project ledger num editor
      this.taxCodeEditCellSetup();  // Tax code
      this.ledgerDimensionEditCellSetup(); // Ledger dimension

      this.setFromName();
    }
  }

  private setFromName(data: any = null) {
    this.fromName = this.voucherTitleName(this.messageDto, this.voucherDtoList, data);
  }

  private isPostingTypeProject(postingType: number): boolean {
    return this.voucherService.isPostingTypeProject(postingType);
  }

  private isPostingTypeLedger(postingType: number): boolean {
    return this.voucherService.isPostingTypeLedger(postingType);
  }

  private isPostingTypeVendor(postingType: number): boolean {
    return this.voucherService.isPostingTypeVendor(postingType);
  }

  private voucherTitleName(msgDto: MessageViewDto, voucherList: VoucherViewDto[], vendorDto: any): string {
    var fromName: string = null;
    var vendorName: string = null;
    if (this.userIsAdmin) {
      if (msgDto) {
        // FromName
        fromName = '';  //strTrim(msgDto.fromEmail ? msgDto.fromEmail : '') + " " + (msgDto.fromName ? '(' + msgDto.fromName + ')' : '');
        if (msgDto.fromEmail?.length > 0) {
          var fromUsers: UserDto[] = this.users.filter(u => u.email == msgDto.fromEmail);
          if (fromUsers?.length > 0) {
            fromName = fromUsers[0].shortName;
          }
        }

        // Vendor name
        if (vendorDto) {
          vendorName = vendorDto.description;
        }
        else {
          var accountNum = '';
          var vouchers = voucherList?.filter(v => v.balanceAccountDescription?.length > 0);
          if (vouchers.length > 0) {
            accountNum = vouchers[0].balanceAccountNum;
          }
          if (this.voucherGrid?.isEdit) {
            var balanceNumCtrl = this.voucherGridEditFormInputElementGetByColumnName('balanceAccountNum');
            if (balanceNumCtrl) {
              accountNum = balanceNumCtrl.value;
            }
          }
          if (accountNum?.length > 0) {
            var vendors = this.vendorsDefault?.filter(v => v.num == accountNum);
            if (vendors.length > 0) {
              vendorName = vendors[0].description;
            }
          }
        }
      }
      var name = '';
      if (fromName?.length > 0) {
        name = fromName;
      }
      if (vendorName?.length > 0) {
        name = (name.length > 0 ? name + ' / ' : '') + vendorName;
      }
    }
    return name;
  }

  private dataBindCalcStatus() {
    //this.userIsAdmin = this.detailsVm.userIsAdmin;

    this.isAnyVoucherPosted = false;
    this.isStatusColumnVisible = false;
    this.voucherCanApprove = false;
    this.voucherCanHold = false;
    //this.isAllApproved = false;
    this.canEdit = true;

    var isIncomplete: boolean = false;
    this.voucherDtoList?.forEach(v => {
      if (this.voucherService.IsStatusPosted(v.status)) {
        this.isAnyVoucherPosted = true;
      }
      if (this.voucherService.IsStatusNonCreatedOrPendingOrOnHold(v.status)) {
        this.isStatusColumnVisible = true;
      }
      if (v.approver == this.userCurrent.id || (v.approver == null && this.userIsAdmin)) {
        if (!this.voucherService.IsStatusNonCreatedOrPendingOrOnHold(v.status)) {
          this.voucherCanApprove = true;
          if (!this.voucherService.voucherIsComplete(v, this.userIsAdmin, this.isExpenseVoucher)) {
            isIncomplete = true;
          }
          this.voucherCanHold = this.voucherService.IsStatusPendingOrCreated(v.status);
        }
        if (this.voucherService.IsStatusApproved(v.status)) {
          this.voucherCanHold = true;
        }
      }
      if (this.voucherService.IsStatusAccountedOrPosted(v.status)) {
        this.canEdit = false;
      }
    });

    var hasApprovedByChat = (!this.userIsAdmin && this.detailsVm?.chatDtoList != null && this.detailsVm.chatDtoList.length > 0);
    this.voucherCanApproveByPostingEdit = (this.voucherCanApprove && !isIncomplete && !hasApprovedByChat);

    var amountSum: number = 0;
    this.postingDtoListAll.forEach(p => {
      if (!this.voucherService.postingIsComplete(p, this.userIsAdmin)) {
        isIncomplete = true;
      }
      amountSum += p.amountCur;
    });
    if (Math.abs(amountSum) > 0.001) {
      isIncomplete = true;
    }

    this.voucherCanApprove = (this.voucherCanApprove && !isIncomplete) || hasApprovedByChat;
    this.voucherCanHold = this.voucherCanHold && !this.userIsAdmin;

    this.voucherIsStatusCreated =
      this.voucherDtoList?.filter(v => v.status == VoucherApprovalStatusEnum.Created)?.length > 0;
    this.voucherGridEditSettings.allowEditing = this.canEdit && (this.userIsAdmin || this.voucherIsStatusCreated);
    this.voucherGridEditSettings.allowAdding = false;
    this.voucherGridEditSettings.allowDeleting = false;
    if (!this.canEdit) {
      this.voucherGridToolbar = (<any[]>this.voucherGridToolbar).filter(i => i.id != null);
    }

    this.postingGridEditSettings.allowEditing = this.canEdit;
    this.postingGridEditSettings.allowDeleting = this.canEdit;
    this.postingGridEditSettings.allowAdding = this.canEdit;
    if (!this.canEdit) {
      this.postingGridToolbar =
        [] /* (<any[]>this.postingGridToolbar).filter(i =>  (i.id == null || ['postingDelete','postingAdjustAmounts','postingAdd'].includes(i.id))) */;
    }
  }

  private voucherCanApproveByPostingEditCalc(postingEditDataPassed: PostingViewDto = null) {
    if (this.voucherCanApproveByPostingEdit) {

      var amountSum: number = 0;
      var isIncomplete = false;


      var postingDtoFull: PostingViewDto = new PostingViewDto();
      Object.assign(postingDtoFull, this.postingDtoEdit);

      var postingEditData: PostingViewDto = (postingEditDataPassed != null) ? postingEditDataPassed : this.postingGrid.isEdit ? this.gridCurrentEditDtoGet(this.postingGrid) : null;
      if (postingEditData != null) {
        Object.assign(postingDtoFull, postingEditData);
      }

      this.postingDtoListAll.forEach(p => {
        if (!postingDtoFull || p.id != postingDtoFull.id) {
          if (!this.voucherService.postingIsComplete(p, this.userIsAdmin)) {
            isIncomplete = true;
          }
          amountSum += p.amountCur;
        }
      });

      if (postingDtoFull && !this.voucherService.postingIsComplete(postingDtoFull, this.userIsAdmin)) {
        isIncomplete = true;
      }
      amountSum += postingDtoFull.amountCur;

      if (Math.abs(amountSum) > 0.001) {
        isIncomplete = true;
      }
      this.postingGrid.aggregateModule.refresh(postingEditData);

      this.voucherCanApprove = !isIncomplete;
    }
  }

  /*
  private voucherInitFromMessage(dto: VoucherDto): boolean {
    let ok: boolean = false;
    let messageDto = this.messageDtoList[0];
    if (messageDto.id) {
      ok = true;
      dto.msgId = messageDto.id;
      let dtoPrev: VoucherDto = this.voucherGridRowActive();
      if (dtoPrev) {
        dto.approver = dtoPrev.approver;
        dto.approverName = dtoPrev.approverName;
        dto.approverShortName = dtoPrev.approverShortName;
        dto.currency = dtoPrev.currency;
        dto.currencyISO = dtoPrev.currencyISO;
        dto.currencyName = dtoPrev.currencyName;
        dto.documentDate = dtoPrev.documentDate;
        dto.documentNum = dtoPrev.documentNum;
        dto.notes = dtoPrev.notes;
        dto.recieved = dtoPrev.recieved;
        dto.status = dtoPrev.status;
        dto.statusName = dtoPrev.statusName;
        dto.transDate = dtoPrev.transDate;
        dto.txt = dtoPrev.txt;
        dto.voucherNum = dtoPrev.voucherNum;
        dto.channelNum = dto.channelNum;
        dto.channelName = dto.channelName;
      }
      else {
        dto.txt = messageDto.subject;
        dto.recieved = messageDto.recieved;
        dto.transDate = messageDto.recieved;
        dto.channelNum = messageDto.channelNum;
        dto.channelName = messageDto.channelName;
      }
    }
    return ok;
  }
  */

  protected postingGridLoad(args: any) {
    this.gridEditRowOnClickSetup(this.postingGrid);
  }

  /*
  private voucherGridLoad(args: any) {
  }
  */

  private gridEditRowOnClickSetup(grid: GridComponent) {
    grid.element.addEventListener('mouseup', (e: MouseEvent) => {
      this.gridEditRowOnClick(grid, e);
    });
  }

  private gridEditRowOnClick(grid: GridComponent, e: MouseEvent) {
    var target: HTMLElement = e.target as HTMLElement;
    if (target?.classList.contains("e-rowcell")) {
      let rowInfo = grid.getRowInfo(e.target);
      this.gridEditRow(grid, rowInfo);
    };
  }

  private gridEditRow(grid: GridComponent, rowInfo: RowInfo) {
    if (grid) {
      if (grid.editSettings.allowEditing) {
        var colIdx: number = rowInfo?.cellIndex;
        if (colIdx) {
          var col: Column = grid?.getColumnByIndex(colIdx);
          this.voucherClickTarget = grid == this.voucherGrid ? col : null;
          this.postingClickTarget = grid == this.postingGrid ? col : null;
        }
        if (this.voucherGrid.isEdit || this.postingGrid.isEdit) {
          this.gridDeferred = grid;
          this.gridRequestTypeDeferred = 'beginEdit';
          this.gridSelectRowIdxDeferred = rowInfo.rowIndex;
          this.gridEditSaveCancel(this.voucherGrid);
          this.gridEditSaveCancel(this.postingGrid);
        }
        else {
          grid.selectRow(rowInfo.rowIndex);
          if (grid.selectedRowIndex >= 0) {
            grid.startEdit();
          }
        }
      }
      else {
        grid.selectRow(rowInfo.rowIndex);
      }
    }
  }

  private isEqual(obj1: any, obj2: any): boolean {
    var s1: string = JSON.stringify(obj1, function (k, v) { return v === undefined ? null : v; });
    var s2: string = JSON.stringify(obj2, function (k, v) { return v === undefined ? null : v; });
    return (s1 === s2);
  }

  private gridCurrentEditedDataGet(grid: GridComponent, dto: any = {}): any {
    var editData: any = dto;
    if (grid != null && grid.editModule != null && grid.isEdit) {
      var form: Element = this.gridEditFormElementGet(grid);
      if (form != null) {
        try {
          editData = grid.editModule.getCurrentEditedData(form, dto);
        }
        catch {
          console.error("Error getting edit data");
        }
      }
    }
    return editData;
  }

  private gridOriginalEditDtoGet(grid: GridComponent): any {
    return grid.editModule?.editModule?.previousData;
  }

  private gridCurrentEditDtoGet(grid: GridComponent): any {
    var dto: any = null;
    if (grid?.editModule?.editModule != null) {
      var dtoOrig: any = this.gridOriginalEditDtoGet(grid);
      dto = this.gridCurrentEditedDataGet(grid, extend({}, {}, dtoOrig, true)) ?? dtoOrig;
    }
    return dto;
  }

  private isEditUnchanged(grid: GridComponent, dtoChanged: any = null): boolean {
    var dtoOrig: any = grid.editModule.editModule.previousData;
    var dtoEdit: any = this.gridCurrentEditDtoGet(grid);
    return this.isEqual(dtoEdit, dtoOrig);
  }

  private gridEditSaveCancel(grid: GridComponent, forceCancelEdit: boolean = false, skipCancelUi: boolean = false, forceSaveEdit: boolean = true): boolean {
    var doSave: boolean = false;
    if (grid && grid.isEdit) {
      if (forceCancelEdit || this.isEditUnchanged(grid)) {
        if (!skipCancelUi) {
          if (grid == this.voucherGrid) {
            this.voucherSkipCancelDialog = true;
          }
          grid.closeEdit();
        }
      }
      else {
        grid.endEdit();
        this.gridAwaitRefresh = true;
        doSave = true;
      }
    }
    return doSave;
  }

  private gridEditFormElementGet(grid: GridComponent): HTMLFormElement {
    return grid.editModule?.formObj?.element;
  }

  protected voucherGridRowSelected(args: any) {
    //console.log('voucherGridRowSelected ' + args.rowIndex);
    this.voucherDtoActive = args.data;
    this.gridOnRowSelectedDeferredNotify(this.voucherGrid, args.RowIndex);
    this.gridsActionDeferred();
  }

  protected postingGridRowSelected(args: any) {
    //console.log('postingGridRowSelected ' + args.rowIndex);
    this.gridOnRowSelectedDeferredNotify(this.postingGrid, args.rowIndex);
    this.gridsActionDeferred();
  }

  private voucherSave(dto: VoucherViewDto) {
    this.gridNavigationCmd == GridNavigationCmd.None;
    //this.gridEditSaveCancel(this.voucherGrid, forceCancelEdit);
    this.voucherGridIsDataBound = false;
    this.postingGridIsDataBound = false;
    if (dto.msgId) {
      if (dto.id) {
        this.apiVoucherPutPromise(dto).then(detailsVm => {
          this.voucherSavePost(detailsVm, dto);
        }).catch(error => {
          this.ui.errorApi(error);
          this.detailsVmGet(dto.msgId);
        });
      }
    }
    else {
      let voucherDto = new VoucherViewDto();
      for (var c in dto) {
        (<any>voucherDto)[c] = (<any>dto)[c];
      }
      this.apiVoucherPostPromise(dto).then(detailsVm => {
        this.voucherSavePost(detailsVm, dto);
      });
    }
  }

  private voucherApprovalStatusSetDeferred: VoucherApprovalStatusEnum = null;  // Set status after save complete
  private voucherSavePost(detailsVm: DetailsVm, voucherDtoUpdated: VoucherViewDto) {
    if (this.voucherApprovalStatusSetDeferred) {
      this.voucherApprovalStatusSetDeferred = null;
      this.setApprovalStatusPromise(voucherDtoUpdated?.id, this.voucherApprovalStatusSetDeferred).then(voucherDto => {
        this.detailsVmReBind(detailsVm, voucherDto.id);
      });
    }
    else {
      this.detailsVmReBind(detailsVm, voucherDtoUpdated.id);
    }
  }

  private apiVoucherPutPromise(dto: VoucherViewDto): Promise<DetailsVm> {
    let forceUpdateAmountCur: boolean = true;
    return new Promise<DetailsVm>((resolve, reject) => {
      var detailsVm: DetailsVm = null;
      this.detailsClient.putVoucher(dto.msgId, forceUpdateAmountCur, dto).subscribe({
        next: (detailsVmReturn: DetailsVm) => {
          detailsVm = detailsVmReturn;
          resolve(detailsVm);
          if (detailsVm.approversNextOption?.length > 0) {
            this.voucherApproverNextSelect(dto.id, detailsVm.approversNextOption);
          }
        },
        error: (error) => {
          this.ui.errorApiAction(error).then(action => {
            if (action == 'retry') {
              this.apiVoucherPutPromise(dto).then((detailsVm => resolve(detailsVm))); // Force update of amountCur (respond to http 422)
            }
            else {
              this.actionSetDeferred(null);
              this.detailsVmGetPromise(dto.msgId).then(detailsVm => resolve(detailsVm));
            }
          });
        }
      });
    });
  }


  private voucherApproverNextSelect(voucherId: number, approversNextOption: number[]): Promise<void> {
    return new Promise<void>((resolve) => {
      this.getApproverInput(approversNextOption[0], 'Bilag kræver yderligere godkender', 'Endelig godkender', 'Angiv endelig godkender', approversNextOption)
        .then((nextApprover) => {
          if (nextApprover != null) {
            this.apiVoucherApproverPostPromise(voucherId, nextApprover).then(() => resolve());
          }
          else {
            resolve();
          }
        })
        .catch(() => {
          resolve();
        });
    });
  }

  private apiVoucherApproverPostPromise(voucherId: number, nextApprover: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.detailsClient.postVoucherApprover(voucherId, nextApprover, false).subscribe({
        next: () => {
          resolve();
        },
        error: (error) => {
          this.ui.errorApi(error);
          reject();
        }
      });
    });
  }

  private apiVoucherPostPromise(dto: VoucherViewDto): Promise<DetailsVm> {
    return new Promise<DetailsVm>((resolve, reject) => {
      this.detailsClient.postVoucher(dto).subscribe({
        next: (detailsVm: DetailsVm) => {
          resolve(detailsVm);
        },
        error: (error) => {
          this.ui.errorApi(error);
          this.detailsVmGet(dto.msgId);
          reject(error);
        }
      });
    });
  }

  private apiVoucherDeletePromise(dto: VoucherViewDto): Promise<DetailsVm> {
    return new Promise<DetailsVm>((resolve) => {
      this.gridNavigationCmd == GridNavigationCmd.None;
      var detailsVm: DetailsVm = null;
      if (dto?.id != null) {
        this.detailsClient.deleteVoucher(dto.msgId, dto.id).subscribe({
          next: (detailsVmUpdated: DetailsVm) => {
            detailsVm = detailsVmUpdated;
            this.detailsVm = detailsVm;
            this.detailsVmMap.set(this.detailsVm.voucherMessageViewDto.id, this.detailsVm);
            //this.dataBindGrids(this.getLastVoucherId(this.detailsVm.voucherViewDtoList));
          },
          error: (error) => {
            this.error(["Fejl ved sletning af godkendelse", error]);
          },
          complete: () => {
            resolve(detailsVm);
          }
        });
      }
      else {
        resolve(detailsVm);
      }
    });
  }

  private getLastVoucherId(dtoList: VoucherViewDto[]): number {
    var lastVoucherId: number = null;
    if (dtoList && dtoList.length > 0) {
      lastVoucherId = dtoList[dtoList.length - 1].id;
    }
    return lastVoucherId;
  }

  private postingInitFromVoucher(dto: PostingViewDto): boolean {
    let ok: boolean = false;
    let voucherDto = this.voucherGridRowActive();
    if (voucherDto.id) {
      ok = true;
      dto.id = null;
      dto.postingType = this.isExpenseVoucher ? VoucherPostingTypeEnum.Ledger : VoucherPostingTypeEnum.Project;
      dto.msgId = voucherDto.msgId;
      dto.voucherId = voucherDto.id;
      dto.txt = voucherDto.txt;
      //if (this.postingDtoListAll?.length < 2) {
      dto.amountCur = voucherDto.amountCur;
      //}
      dto.transDate = voucherDto.transDate;

      let dtoPrev: PostingViewDto = this.postingGridLastRow(voucherDto);
      if (dtoPrev) {
        dto.postingType = this.isExpenseVoucher ? VoucherPostingTypeEnum.Ledger : VoucherPostingTypeEnum.Project;
        dto.lineNum = dtoPrev.lineNum + 1;
      }
      else {
        dto.postingType = this.isExpenseVoucher ? VoucherPostingTypeEnum.Bank : VoucherPostingTypeEnum.Vendor;
        dto.lineNum = 1;
      }
    }
    return ok;
  }

  private clone(from: any, to: any) {
    to = structuredClone(from);
    /*
    for (var attribut in from) {
      if (typeof from[attribut] === "object" && from[attribut] != null) {
        to[attribut] = from[attribut].clone();
      } else {
        to[attribut] = from[attribut];
      }
    }
    */
  }

  private postingAdjustAmountsConfirm() {
    var _this: VoucherDetailComponent = this;
    this.ui.confirm("Fordel beløb konteret til at matche fakturabeløb?").then(result => {
      if (result == 'ok') {
        _this.actionRun("AdjustAmounts");
      }
    }
    );
  }

  private postingAdjustAmountsApi(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      var msgId: number = this.detailsVm.voucherMessageViewDto.id;
      this.utilClient.adjustPostingAmountToVoucher(msgId).subscribe({
        next: (result) => {
          this.detailsVm = result;
          this.detailsVmMap.set(msgId, this.detailsVm);
          this.dataBindGrids();
          resolve();
        },
        error: (error) => {
          this.ui.errorApi(error);
        }
      });
    });
  }

  private postingSave(dto: PostingViewDto, gridRowIdx: number) {
    this.gridNavigationCmd == GridNavigationCmd.None;
    if (dto.msgId) {
      if (dto.id) {
        var postingDto: PostingViewDto = dto;
        this.detailsClient.putPosting(dto).subscribe({
          next: (result) => {
            postingDto = result;
            this.postingPutResultApply(postingDto, dto);
            this.postingGridRefreshSavedData(gridRowIdx);
          },
          error: (error) => {
            this.ui.errorApi(error);
            this.detailsVmGet(dto.msgId);
          },
        });
      }
      else {
        this.detailsClient.postPosting(dto).subscribe({
          next: (result) => {
            this.postingPostResultApply(dto, result);
            this.gridNavigationCmd = GridNavigationCmd.PostingLast;
            this.postingGridRefreshSavedData(gridRowIdx);
          },
          error: (error) => {
            this.error(error);
            this.detailsVmDataBind();
          }
        });
      }
    }
  }

  private postingDelete(dtoList: PostingViewDto[]) {
    this.gridNavigationCmd == GridNavigationCmd.None;
    for (var dto of dtoList) {
      this.detailsClient.deletePosting(dto.msgId, dto.id).subscribe({
        next: (result) => {
          this.postingDeleteResultApply(dto);
          this.gridNavigationCmd = GridNavigationCmd.PostingLast;
          this.postingGridRefresh(-1);
        },
        error: (error) => {
          this.ui.errorApi(error);
          this.detailsVmGet(dto.msgId);
        }
      });
    }
  }

  private postingPostResultApply(dto: PostingViewDto, result: PostingViewDto) {
    var idx = this.postingDtoList.findIndex(function (element) { return element.id === dto.id; });
    if (idx !== -1) {
      this.postingDtoList.splice(idx, 1);
    }
    this.postingDtoList.push(result);

    if (!this.userIsAdmin) {
      var idx = this.postingDtoListAll.findIndex(function (element) { return element.id === dto.id; });
      if (idx !== -1) {
        this.postingDtoListAll.splice(idx, 1);
      }
      this.postingDtoListAll.push(result);
    }
  }

  private postingPutResultApply(result: PostingViewDto, dto: PostingViewDto) {
    this.clone(result, dto);
    this.postingGrid.setRowData(dto.id, dto);
    var idx = this.postingDtoList.findIndex(function (element) { return element.id === result.id; });
    if (idx !== -1) {
      this.postingDtoList.splice(idx, 1, dto);
    }
    else {
      this.postingDtoList.push(dto);
    }
    idx = this.postingDtoListAll.findIndex(function (element) { return element.id === result.id; });
    if (idx !== -1) {
      this.postingDtoListAll.splice(idx, 1, dto);
    }
    else {
      this.postingDtoListAll.push(dto);
    }
  }

  private postingGridRefreshSavedData(gridRowIdx: number) {
    this.dataBindCalcStatus();
    this.postingGridRefresh(gridRowIdx);
    this.actionRunDeferred();
  }

  private postingDeleteResultApply(dto: PostingViewDto) {
    var idx = this.postingDtoList.findIndex(function (element) { return element.id === dto.id; });
    if (idx !== -1) {
      this.postingDtoList.splice(idx, 1);
    }

    idx = this.postingDtoListAll.findIndex(function (element) { return element.id === dto.id; });
    if (idx !== -1) {
      this.postingDtoListAll.splice(idx, 1);
    }
  }

  private postingAmountCurAggregateRow(row: PostingViewDto): number {
    var amountCur: number = row.amountCur;
    if (this.postingGrid.isEdit && this.postingDtoEdit && this.postingDtoEdit.id == row.id && this.postingAmountCurEditValue) {
      amountCur = this.postingAmountCurEditValue;
    }
    return amountCur;
  }

  protected postingAmountCurAggregate: CustomSummaryType = (data: any, column: AggregateColumnModel) => {
    var credit: number = 0;
    var debit: number = 0;
    var vendor: number = 0;
    var voucher: number = 0;

    if (this.voucherDtoList) {
      this.voucherDtoList.filter((row: VoucherViewDto) => { voucher += row.amountCur; });
    }

    //if (data.result.records) {
    //  data.result.records.filter((row: PostingDto) => {
    if (this.postingDtoListAll) {
      this.postingDtoListAll.filter((row: PostingViewDto) => {
        var amt: number = this.postingAmountCurAggregateRow(row);
        if (this.voucherService.isPostingTypeVendor(row.postingType)) {
          vendor += amt;
        }
        if (amt < 0) {
          credit -= amt;
        }
        else {
          debit += amt;
        }
      });
    }

    if (this.postingGrid?.isEdit && this.postingDtoEdit && this.postingDtoEdit.id == Number.MAX_SAFE_INTEGER && this.postingAmountCurEditValue) {
      // In insert
      var amt: number = this.postingAmountCurAggregateRow(this.postingDtoEdit);
      if (amt < 0) {
        credit -= amt;
      }
      else {
        debit += amt;
      }
    }

    voucher = Math.round(voucher * 100) / 100;
    const voucherAbs = Math.abs(voucher);
    vendor = Math.round(vendor * 100) / 100;
    credit = Math.round(credit * 100) / 100;
    debit = Math.round(debit * 100) / 100;

    let agg: string = 'OK';
    const unmatchedVoucher: boolean = (voucher && (credit < voucherAbs || debit < voucherAbs));
    const unbalancedPosting: boolean = (credit != debit);
    const missingVendorPosting: boolean = (!this.isExpenseVoucher && voucher != -vendor);

    let showAmounts: boolean = (unmatchedVoucher || unbalancedPosting || missingVendorPosting);
    let isLabel = column.columnName == 'postingType';
    if (isLabel) {
      agg = '';
      if (showAmounts) {
        agg = '<div>Debit</div>';
        agg += '<div>Kredit</div>';
        if (Math.abs(debit - credit) >= 0.01) {
          agg += '<div>Diff</div>';
        }
        if (unmatchedVoucher || missingVendorPosting) {
          agg += '<div>Bilag</div>';
        }
        if (missingVendorPosting) {
          agg += '<div>Kreditor</div>';
        }
      }
    }
    else {
      if (showAmounts) {
        let intl: Internationalization = new Internationalization();
        let nFormatter: Function = intl.getNumberFormat({ skeleton: 'N2', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        agg = '<div>' + nFormatter(debit) + '</div>';
        agg += '<div> ' + nFormatter(-credit) + '</div>';
        if (Math.abs(debit - credit) >= 0.01) {
          agg += '<div> ' + nFormatter(debit - credit) + '</div>';
        }
        if (unmatchedVoucher || missingVendorPosting) {
          agg += '<div>' + nFormatter(voucher) + '</div>';
        }
        if (missingVendorPosting) {
          agg += '<div>' + nFormatter(vendor) + '</div>';
        }
      }
    }

    return agg;
  }
  // ----------------------- DIALOG ------------------

  private error(message: string | string[]) {
    this.info(message);
  }

  private info(message: string | string[]) {
    let content: string = '';
    if (Array.isArray(message)) {
      message.forEach(function (s) { content = (content == '' ? '' : content + '<br/>') + s.toString() });
    }
    else {
      content = message;
    }

    this.ui.infoToast(content);
  }

  // ----------------------- GRID ------------------

  private voucherGridRowActive(): VoucherViewDto {
    if (this.voucherDtoList && this.voucherDtoList.length == 1) {
      return this.voucherDtoList[0];
    }
    else if (this.voucherDtoActive && this.voucherDtoActive.id) {
      return this.voucherDtoList.find(voucher => voucher.id == this.voucherDtoActive.id);
    }
    else {
      return this.voucherDtoList[this.voucherDtoList.length - 1];
    }
  }

  private gridGetRowIdxById(gridComponent: GridComponent, id: number): number {
    var data = <any[]>gridComponent.getCurrentViewRecords();
    var rec = data.filter(function (r) { return r.id == id })[0];
    return data.indexOf(rec);
  }


  private gridGetFirstSelectedRecord(grid: GridComponent) {
    var record: any = null;
    if (grid) {
      var selectedRecords: Object[] = grid.getSelectedRecords();
      if (selectedRecords.length > 0) {
        record = selectedRecords[0];
      }
    }
    return record;
  }

  voucherGridGetFirstSelectedDto(): VoucherViewDto {
    return <VoucherViewDto>this.gridGetFirstSelectedRecord(this.voucherGrid);
  }

  voucherGridActionBegin(args: any) {
    if (this.gridDeferRequestType(this.voucherGrid, args)) {
      args.cancel = true;
      return;
    }
    switch (args.requestType) {
      case 'save':
        args.cancel = true;
        this.voucherSave(args.data);
        break;
      case 'cancel':
        if (this.voucherSkipCancelDialog) {
          this.voucherSkipCancelDialog = false;
        }
        else {
          args.cancel = this.cancelNeedConfirm(this.voucherGrid, args);
        }
        break;
      case 'add':
        args.cancel = true;
        if (this.postingGrid.editSettings.allowAdding) {
          this.postingGrid.addRecord();
        }
        break;
      case 'delete':
        args.cancel = true;
        if (this.postingGrid.editSettings.allowDeleting) {
          this.postingGrid.deleteRecord();
        }
        break;
    }
    //console.log("Voucher Action begin " + args.requestType + " / cancel=" + args.cancel);
  }
  private voucherEditFocus() {
    if (this.voucherClickTarget) {
      this.gridEditFocus(this.voucherGrid, this.voucherClickTarget);
      this.voucherClickTarget = null;
    }
  }

  private postingEditFocus() {
    if (this.postingClickTarget) {
      this.gridEditFocus(this.postingGrid, this.postingClickTarget);
      this.postingClickTarget = null;
    }
  }

  private gridEditFocus(grid: GridComponent, col: Column) {
    var edit: any = grid?.editModule;
    var render: any = edit?.renderer;
    if (render) {
      var form = this.gridEditFormElementGet(grid);
      var cell = form?.querySelector('[e-mappinguid=' + col.uid + ']');
      if (cell && !cell.getAttribute('disabled') && !parentsUntil(cell, 'e-checkbox-disabled')) {
        cell = cell.querySelector('[e-mappinguid=' + col.uid + ']') ?? cell;
        render.focusElement(cell, 'initialFocus');

      }
    }
  }

  voucherGridActionFailure(args: any) {
    console.log("Voucher Action Failure");
    console.log(args);
  }

  voucherGridActionComplete(args: any) {
    switch (args.requestType) {
      case 'refresh':
        if (this.gridDeferred == this.voucherGrid) {
          this.gridAwaitRefresh = false;
        }
        this.gridsActionDeferred();
        break;
      case 'beginEdit':
        this.voucherPostBeginEditAdd(args);
        this.voucherEditFocus();
        break;
      case 'add':
        this.voucherPostBeginEditAdd(args);
        break;
      case 'cancel':
        this.resetVendorPostingProforma();
        this.resetProjectPostingProforma();
        break;
    }
    //console.log("Voucher Action complete " + args.requestType + " / cancel=" + args.cancel);

  }

  private voucherPostBeginEditAdd(args: any) {
    this.voucherDtoActive = args.rowData;
    // Prepare columns
    this.voucherGridInitControls();
    for (var i = 0; i < args.form.elements.length; i++) {
      if (args.form.elements[i].name == 'balanceAccountNum') {
        this.balanceAccountNumElement = args.form.elements[i];
        this.balanceAccountNumElement.onchange = (args) => {
          this.checkDocumentNumUniqueByEdit();
        };
      }
      if (args.form.elements[i].name == 'documentNum') {
        this.documentNumElement = args.form.elements[i];
        this.documentNumElement.onchange = (args) => {
          this.checkDocumentNumUniqueByEdit();
        };
      }
    }
  }

  // Confirm cancel
  private cancelNeedConfirm(grid: GridComponent, args: any) {
    var cancelEvent: boolean = false;
    if (this.gridCancelledConfirmed == null) {
      if (!this.isEditUnchanged(grid, args.rowData)) {
        // Cancel confirm (can be migrated to promise)
        cancelEvent = true;
        this.confirmCancelDialogShow(grid);
      }
    }
    else {
      this.gridCancelledConfirmed = null; // Handle confirm complete
    }
    return cancelEvent;
  }

  private checkDocumentNumUniqueByEdit() {
    var vendorAccountNum: string = this.balanceAccountNumElement != null ? this.balanceAccountNumElement.value : null;
    var documentNum: string = this.documentNumElement != null ? this.documentNumElement.value : null;
    this.checkDocumentNumUniqueApi(vendorAccountNum, documentNum);
  }

  private checkDocumentNumUniqueByVoucher(voucher: VoucherViewDto) {
    this.checkDocumentNumUniqueApi(voucher.balanceAccountNum, voucher.documentNum);
  }

  private checkDocumentNumUniqueApi(vendorAccountNum: string, documentNum: string) {
    if (vendorAccountNum && documentNum) {
      this.utilClient.isVendorDocumentNumUnique(this.detailsVm.voucherMessageViewDto.id, vendorAccountNum, documentNum).subscribe(
        data => { if (data.voucherViewDtoList && data.voucherViewDtoList.length > 0) { this.showDocumentNumInfo(data.voucherViewDtoList[0], vendorAccountNum, documentNum); } }
      );
    }
  }

  private showDocumentNumInfo(voucher: VoucherViewDto, vendorAccountNum: string, documentNum: string) {
    this.ui.info(
      "Faktura " + documentNum + " er registreret for kreditor " + vendorAccountNum + (voucher.voucherNum ? " - Bilag " + voucher.voucherNum + " findes allerede." : ""),
      "Faktura " + documentNum + " er brugt på kreditor " + vendorAccountNum
    );
  }

  private confirmCancelDialogShow(grid: GridComponent) {
    this.gridCancelledConfirmed = grid;
    this.ui.confirm(
      "Inddata er ændret. Fortryd redigering?",
      "Bekræft").then(action => {
        var methodBind = null;
        if (action = 'ok') {
          methodBind = this.confirmCancelDialogOkClick.bind(this);
        }
        else {
          methodBind = this.confirmCancelDialogCancelClick.bind(this);
        }
        methodBind();
      }
      );
  }

  private confirmCancelDialogOkClick() {
    if (this.gridCancelledConfirmed && this.gridCancelledConfirmed.isEdit) {
      this.gridCancelledConfirmed.closeEdit();
    }
  }

  private confirmCancelDialogCancelClick() {
    this.gridCancelledConfirmed = null;
  }

  private gridActionIs(args: any, actions: string[] | string): boolean {
    let ok: boolean = false;

    if (Array.isArray(actions)) {
      ok = (actions.includes(args.requestType));
    }
    else {
      ok = (actions.includes(args.requestType));
    }
    return ok;
  }

  // Grid row double clicked: Edit row
  public postingGridRecordDoubleClick(args: any) {

    //    (<any>this.voucherGrid.contextMenuModule).element.ej2_instances[0].openMenu(null, null, (<any>event).pageY, (<any>event).pageX, event);
  }

  // Voucher grid toolbar
  public voucherGridToolbarClick(args: ClickEventArgs) {
    switch (args.item.id) {
      case 'attachmentsShowHide':
        this.attachmentsShowHide()
        break;
    }
  }

  // Shortcuts
  public handleKeyDownEvent(event: KeyboardEvent) {
    //console.log(event);
    if (event.code == 'Escape') {
      if (this.attachmentsIsActive) {
        this.attachmentsShowHide()
        event.preventDefault();
      }
    }
    else if (event.altKey == true && !event.ctrlKey && !event.shiftKey) {
      switch (event.code) {
        case 'KeyV':
          this.attachmentsShowHide();
          break;
        case 'KeyS':
          if (!this.actionDisabledClass) {
            this.actionRun(!this.canEdit ? 'Close' : (this.canSendToPending == true ? 'PendingApprovalAndClose' : 'SaveAndClose'));
          }
          break;
        case 'KeyX':
          if (!this.actionDisabledClass) {
            this.actionRun('Close');
          }
          break;
        case 'KeyG':
          if (!this.actionDisabledClass) {
            if (this.canEdit && this.voucherCanApprove) {
              this.actionRun('ApprovedAndClose');
            }
          }
          break;
        case 'KeyO':
          if (this.attachmentsIsActive) {
            this.tabAttachments.openAttachInNewTab(false);
          }
          break;
        case 'NumpadAdd':
          if (this.attachmentsIsActive) {
            this.tabAttachments.pdfZoomIn();
            event.preventDefault();
          }
          break;
        case 'NumpadSubtract':
          if (this.attachmentsIsActive) {
            this.tabAttachments.pdfZoomOut();
            event.preventDefault();
          }
          break;
      }
    }
    else if (event.altKey && !event.ctrlKey && event.shiftKey) {
      switch (event.code) {
        case 'PageUp': // Alt+Shift+PgUp
          this.gridsNavigationCmdSelect(this.userIsAdmin ? GridNavigationCmd.Voucher : GridNavigationCmd.PostingFirst);
          break;
        case 'PageDown': // Alt+Shift+PgDn
          this.gridsNavigationCmdSelect(GridNavigationCmd.PostingLast);
          break;
        case 'NumpadAdd': // Alt +
          this.splitterResize(100);
          event.preventDefault();
          break;
        case 'NumpadSubtract': // Alt -
          this.splitterResize(-100);
          event.preventDefault();
          break;
      }
    }
    else if (event.ctrlKey == true && !event.altKey && !event.shiftKey) {
      switch (event.code) {
        case 'ArrowRight':
          this.attachmentsShowHide();
          break;
      }
    }
  }

  // Grid context menu click
  public voucherGridContextMenuClick(args: ContextMenuClickEventArgs) {
    //console.log("Context menu id: "+args.item.id);
    switch (args.item.id) {
      case 'dataBind':
        this.detailsVmGetPromise(this.callerMsgId).then();
        break;
      case 'gridColumnGroup':
        var columnName = <string>args.column.field;
        if (columnName) {
          this.voucherGrid.groupColumn(columnName);
          this.voucherGrid.groupSettings.showDropArea = true;
        }
        break;
      case 'gridColumnHide':
        var columnName = <string>args.column.field;
        if (columnName) {
          this.voucherGrid.hideColumns(columnName, 'field');
        }
        break;
      case 'gridColumnsChoose':
        this.voucherGrid.openColumnChooser();
        break;
      case 'gridExcelExport':
        this.voucherGrid.excelExport(<ExcelExportProperties>{ fileName: this.routerShortUrl() + '.xlsx' });
        break;
      case 'setStatusPending':
        this.setApprovalStatusOnGridContextMenuArgs(args, VoucherApprovalStatusEnum.Pending);
        break;
      case 'setStatusOnHold':
        this.setApprovalStatusOnGridContextMenuArgs(args, VoucherApprovalStatusEnum.OnHold);
        break;
      case 'setStatusApproved':
        this.setApprovalStatusOnGridContextMenuArgs(args, VoucherApprovalStatusEnum.Approved);
        break;
      case 'setStatusAccounted':
        this.setApprovalStatusOnGridContextMenuArgs(args, VoucherApprovalStatusEnum.Accounted);
        break;
      case 'setStatusPosted':
        this.setApprovalStatusOnGridContextMenuArgs(args, VoucherApprovalStatusEnum.Posted);
        break;
    }
  }

  private voucherGridContextMenuArgsToDto(args: ContextMenuClickEventArgs | ContextMenuOpenEventArgs): any {
    var dto: any;
    if (this.voucherGrid && this.voucherGrid.isEdit) {
      dto = this.gridCurrentEditDtoGet(this.voucherGrid);
    }
    else {
      dto = (args.rowInfo != null ? args.rowInfo.rowData : null);
    }
    return dto;
  }

  private setApprovalStatusOnGridContextMenuArgs(args: ContextMenuClickEventArgs, status: VoucherApprovalStatusEnum) {
    if (this.voucherGrid.isEdit) {
      this.voucherApprovalStatusSetDeferred = status;
      this.voucherGrid.endEdit();
    }
    else {
      var voucherDto: VoucherViewDto = this.voucherGridContextMenuArgsToDto(args);
      if (voucherDto) {
        this.setApprovalStatusPromise(voucherDto.id, status).then((voucherDto) => {
          if (voucherDto.msgId) {
            this.detailsVmMap.delete(voucherDto.msgId);
            this.detailsVmGetPromise(voucherDto.msgId, voucherDto.id).then();
          }
        }
        );
      }
    }
  }

  public voucherGridRecordDoubleClick(args: any) {
    //(<any>this.voucherGrid.contextMenuModule).element.ej2_instances[0].openMenu(null, null, (<any>event).pageY, (<any>event).pageX, event);
  }

  public voucherGridContextMenuOpen(args: ContextMenuOpenEventArgs) {
    if (args != null) {
      var approvalStatus: VoucherApprovalStatusEnum = null;
      var voucherDto: VoucherViewDto = this.voucherGridContextMenuArgsToDto(args);
      approvalStatus = (voucherDto != null ? voucherDto.status : null);
      this.voucherService.EnableContextMenuByApprovalStatus(this.voucherGrid, this.voucherGridContextMenuItems, approvalStatus);
    }
  }

  private setApprovalStatusPromise(voucherId: number, approvalStatus: VoucherApprovalStatusEnum): Promise<VoucherViewDto> {
    return new Promise<VoucherViewDto>((resolve, reject) => {
      if (voucherId == null) {
        var err = "Manglende bilag";
        this.error(["Kan opdatere godkendelsesstatus", err]);
        reject(null);
      }
      else {
        if (this.messageDto.status == VoucherMessageStatusEnum.Inbox) {
          this.setMessageStatusPromise(VoucherMessageStatusEnum.Voucher).then((detailsVmUpdated) => {
            this.apiVoucherSetApprovalStatusPromise([voucherId], approvalStatus)
              .then((voucherDtoUpdated) => resolve(voucherDtoUpdated))
              .catch((err) => reject(err));
          });
        }
        else {
          this.apiVoucherSetApprovalStatusPromise([voucherId], approvalStatus)
            .then((voucherDtoUpdated) => resolve(voucherDtoUpdated))
            .catch((err) => reject(err));
        }
      }
    });
  }

  private apiVoucherSetApprovalStatusPromise(voucherIds: number[], approvalStatus: VoucherApprovalStatusEnum): Promise<VoucherViewDto> {
    return new Promise<VoucherViewDto>((resolve, reject) => {
      if (voucherIds == null || voucherIds.length == 0) {
        var err = "Manglende bilag";
        this.error(["Kan opdatere godkendelsesstatus", err]);
        reject(err);
      }
      else {
        var voucherDto: VoucherViewDto = null;
        this.client.setApprovalStatus(approvalStatus, voucherIds).subscribe(
          {
            next: (voucherViewResponse: VoucherViewResponse) => {
              voucherDto = voucherViewResponse.voucherViewDto;
              resolve(voucherDto);
            },
            error: (error) => {
              this.error(["Kan opdatere godkendelsesstatus", error]);
              reject(err);
            }
          }
        );
      }
    });
  }

  private setMessageStatusPromise(newMessageStatus: VoucherMessageStatusEnum): Promise<DetailsVm> {
    return new Promise<DetailsVm>((resolve, reject) => {
      if (this.detailsVm?.voucherMessageViewDto == null) {
        reject("Ingen meddelelse angivet");
      }
      else {
        if (this.detailsVm.voucherMessageViewDto.status == newMessageStatus) {
          resolve(this.detailsVm);
        }
        else {
          this.apiMessageSetStatusPromise(this.detailsVm.voucherMessageViewDto.id, newMessageStatus)
            .then((messageDtoUpdated) => {
              this.detailsVmGetPromise(messageDtoUpdated.id).then((detailsVm) => {
                resolve(this.detailsVm);
              });
            })
            .catch((err) => {
              reject(err);
            });
        }
      }
    });
  }

  private apiMessageSetStatusPromise(msgId: number, status: VoucherMessageStatusEnum): Promise<MessageViewDto> {
    return new Promise<MessageViewDto>((resolve, reject) => {
      this.messageClient.setStatus(msgId, status, false).subscribe({
        next: (messageDtoUpdated: MessageViewDto) => {
          resolve(messageDtoUpdated);
        },
        error: (error) => {
          this.ui.errorToast("Kunne ikke opdatere meddelelsesstatus", error);
          console.error(error);
        }
      });
    });
  }


  // Interconnected grid functions
  protected voucherGridDataBound(args: any) {
    if (!this.voucherGridIsDataBound) {
      this.voucherGridIsDataBound = true;
      this.gridsOnDataBound();
    }
  }

  protected postingGridDataBound(args: any) {
    if (!this.postingGridIsDataBound) {
      this.postingGridIsDataBound = true;
      this.gridsOnDataBound();
    }
  }

  private gridsOnDataBound() {

    if (this.gridDeferred == null) {
      if (this.canEdit && this.voucherGrid && this.postingGrid && this.voucherGridIsDataBound && this.postingGridIsDataBound) {
        this.gridsSelectRowIdxDeferredCalc();
      }
    }
    this.gridsActionDeferred();
  }

  private gridsNavigationCmdSelect(cmd: GridNavigationCmd) {
    this.gridNavigationCmd = cmd;
    this.gridDeferred = null;
    this.gridSelectRowIdxDeferred = -1;
    this.gridRequestTypeDeferred = null;
    this.gridsSelectRowIdxDeferredCalc();
    this.gridsActionDeferred();
  }

  private gridsSelectRowIdxDeferredCalc() {
    if (this.gridNavigationCmd == GridNavigationCmd.None) {
      return;
    }
    if (this.gridNavigationCmd == GridNavigationCmd.Default) {
      if (this.voucherGrid && this.voucherGrid.editSettings.allowEditing && (this.userIsAdmin || this.voucherIsStatusCreated)) {
        // Default row on voucher?
        var rows: any = this.voucherGrid.dataSource;
        if (rows?.length > 0) {
          if (!this.voucherService.voucherIsComplete(<VoucherViewDto>rows[0], this.userIsAdmin, this.isExpenseVoucher)) {
            this.gridNavigationCmd = GridNavigationCmd.Voucher;
          }
        }
      }
    }

    if (this.gridNavigationCmd == GridNavigationCmd.Voucher) {
      this.gridSelectRowIdxDeferred = 0;
      this.gridDeferred = this.voucherGrid;
      this.gridRequestTypeDeferred = 'beginEdit';
      this.gridNavigationCmd = GridNavigationCmd.None;
    }
    else if (this.postingDtoList.length > 0) {
      var selectPosting: number = -1;
      if (this.gridNavigationCmd == GridNavigationCmd.Default) {
        selectPosting = this.postingGridStartEditDefaultCalc();
      }
      if (this.gridNavigationCmd == GridNavigationCmd.PostingFirst) {
        selectPosting = 0;
      }
      if (this.gridNavigationCmd == GridNavigationCmd.PostingLast) {
        selectPosting = this.postingDtoList.length - 1;
      }
      if (selectPosting >= 0) {
        this.gridDeferred = this.postingGrid;
        this.gridSelectRowIdxDeferred = selectPosting;
        this.gridRequestTypeDeferred = 'beginEdit';
      }
    }
    this.gridNavigationCmd = GridNavigationCmd.None;
  }

  private postingGridStartEditDefaultCalc(): number {
    var idx: number = -1;
    if (this.postingGrid) {
      var rows: any = this.postingGrid.dataSource;
      if (this.postingGrid.editSettings.allowEditing) {
        var r: number = 0;
        if (rows) {
          rows.forEach((row: any) => { if (idx == -1 && !this.voucherService.postingIsComplete(<PostingViewDto>row, this.userIsAdmin)) { idx = r }; r++; });
        }
      }
      //if (idx == -1 && rows?.length > 0) {
      //  idx = rows.length - 1;
      //}
    }
    return idx;
  }

  private gridDeferred: GridComponent = null;
  private gridRequestTypeDeferred: any = null;
  private gridSelectRowIdxDeferred: number = -1;
  private gridAwaitRefresh: boolean = false;

  private gridDeferRequestType(grid: GridComponent, args: any, forceCancelEdit = false): boolean {
    var deferred: boolean = this.gridActionIs(args, ['beginEdit', 'add', 'delete']) &&
      (this.postingGrid.isEdit || this.voucherGrid.isEdit);
    if (deferred) {
      this.gridDeferred = grid;
      this.gridRequestTypeDeferred = args.requestType;
      this.gridSelectRowIdxDeferred = args.rowIndex;
      this.gridEditSaveCancel(this.voucherGrid, forceCancelEdit);
      this.gridEditSaveCancel(this.postingGrid, forceCancelEdit);
    }
    return deferred;
  }

  private gridsActionDeferred() {
    this.voucherGridActionDeferred();
    this.postingGridActionDeferred();
  }

  private voucherGridActionDeferred() {
    this.gridActionDeferred(this.voucherGrid);
  }

  private postingGridActionDeferred() {
    this.gridActionDeferred(this.postingGrid);
  }

  private gridOnRowSelectedDeferredNotify(grid: GridComponent, rowIndex: number) {
    if (this.gridDeferred != grid) {
      return;
    }
    if (rowIndex >= 0 && rowIndex == this.gridSelectRowIdxDeferred) {
      //console.log("Grid select row notify: " + rowIndex + ' Grid: ' + (<any>grid.columns[1]).field);
      if (this.gridRequestTypeDeferred == null) {
        this.gridSelectRowIdxDeferred = -1;
        this.gridDeferred = null;
      }
    }
  }

  private gridActionDeferred(grid: GridComponent) {
    if (this.gridDeferred != grid) {
      return;
    }
    if (this.gridAwaitRefresh) {
      //console.log("Await refresh deferred " + this.gridRequestTypeDeferred);
      return;
    }
    /*
    if (this.gridSelectRowIdxDeferred == -1 && grid == this.voucherGrid &&
      (this.gridRequestTypeDeferred == 'beginEdit' || this.gridRequestTypeDeferred == 'add')) {
      this.gridSelectRowIdxDeferred = 0;
    }
    */
    if (this.gridSelectRowIdxDeferred != -1 &&
      this.gridSelectRowIdxDeferred != grid.selectedRowIndex) {
      grid.selectRow(this.gridSelectRowIdxDeferred);
      return;
    }
    if (this.gridRequestTypeDeferred != null) {
      setTimeout(() => {
        if (this.gridSelectRowIdxDeferred != -1) {
          if (grid.selectedRowIndex != this.gridSelectRowIdxDeferred) {
            grid.selectRow(this.gridSelectRowIdxDeferred);
            return;
          }
        }
        //console.log("Grid request: " + this.gridRequestTypeDeferred + ' Grid: ' + (<any>grid.columns[1]).field);
        var requestType: any = this.gridRequestTypeDeferred;
        this.gridSelectRowIdxDeferred = -1;
        this.gridRequestTypeDeferred = null;
        this.gridDeferred = null;
        if (!grid.isEdit) {
          switch (requestType) {
            case 'beginEdit':
              if (grid.editSettings.allowEditing) {
                if (grid.selectedRowIndex >= 0) {
                  //console.log("start edit (deferred)");
                  grid.startEdit();
                }
                else {
                  console.log(grid.selectedRowIndex);
                  console.log("no row selected (deferred edit)");
                }
              }
              break;
            case 'add':
              if (grid.editSettings.allowAdding) {
                //console.log("add row (deferred)");
                grid.addRecord();
              }
              break;
            case 'delete':
              if (grid.editSettings.allowDeleting) {
                if (grid.selectedRowIndex >= 0) {
                  //console.log("delete (deferred)");
                  grid.deleteRecord();
                }
                else {
                  console.log("no row selected (deferred delete)");
                }
              }
              break;
            case 'startSelectRow':
              console.log("select row (deferred)");
              this.gridsOnDataBound();
          }
        }
      }, 100);
    }
  }

  /*
  private gridSelectedRowIdxSetDeferred(grid: GridComponent) {
    setTimeout(() => {
      if (this.gridSelectRowIdxDeferred != -1) {
        if (this.gridSelectRowIdxDeferred != grid.selectedRowIndex) {
          //console.log("Grid select row: " + this.gridSelectRowIdxDeferred + ' Grid:' + (<any>grid.columns[1]).field);
          grid.selectRow(this.gridSelectRowIdxDeferred);
        }
        else {
          console.log("select row not needed " + this.gridSelectRowIdxDeferred);
        }
      }
    }, 100);
  }
    */

  public gridHeaderCellInfo(args: any): void {
    CerGridCommandService.gridOnHeaderCellInfo(args);
  }

  // Posting grid events
  public postingGridQueryCellInfo(args: any): void {
    VoucherHelper.postingGridQueryCellInfo(args);
  }

  public postingGridActionBegin(args: any) {
    if (this.gridDeferRequestType(this.postingGrid, args)) {
      args.cancel = true;
      return;
    }
    switch (args.requestType) {
      case 'save':
        args.index = this.postingDtoList.length; // Add to end
        this.postingSave(args.data, args.rowIndex ? args.rowIndex : args.index);
        break;
      case 'delete':
        this.postingDelete(args.data);
        break;
      case 'add':
        if (!this.postingInitFromVoucher(args.data)) {
          args.cancel = true;
          this.ui.info('Mangler valgt bilag');
        }
        break;
      case 'cancel':
        args.cancel = this.cancelNeedConfirm(this.postingGrid, args);
        break;
    }
    //console.log("Posting Action begin " + args.requestType + " / cancel=" + args.cancel);
  }

  public postingGridActionComplete(args: any) {
    switch (args.requestType) {
      case 'refresh':
        if (this.gridDeferred == this.postingGrid) {
          this.gridAwaitRefresh = false;
        }
        this.gridsActionDeferred();
        break;
      case 'beginEdit':
        this.postingGridAddEdit(args);
        this.postingEditFocus();
        break;
      case 'add':
        this.postingGridAddEdit(args);
        break;
      case 'cancel':
      case 'save':
        this.postingAmountCurEditValue = null;
        this.postingDtoEdit = null;
        this.dataBindCalcStatus();
        this.postingGrid.aggregateModule.refresh(null);
        if (args.requestType == 'cancel') {
          this.voucherGridActionDeferred();
          this.postingGridActionDeferred();
        }
    }
    //console.log("Posting Action complete " + args.requestType + " / cancel=" + args.cancel);
  }

  private postingGridAddEdit(args: any) {
    this.postingDtoEdit = args.rowData;
    this.postingGridInitControls();
    this.postingGridUpdateDesign(args.rowData);
    this.voucherCanApproveByPostingEditCalc(args.rowData);
  }

  /*
  private voucherGridEndEditIfTouched(): boolean {
    var save: boolean = this.voucherGridEditTouched()
    if (save) {
      this.voucherGrid.endEdit();
    }
    else {
      this.voucherGrid.closeEdit();
    }
    return save;
  }

  private voucherGridEditTouched(): boolean {
    return true;
  }
    */

  public voucherGridInitControls() {
    var i: HTMLInputElement = this.voucherGridEditFormInputElementGetByColumnName('amountCur');
    if (i) {
      var amount: number = this.detailsVm.voucherViewDtoList[0].amountCur;
      this.numericEditAmountCurSetup(i, amount);
      var _this = this;
      i.onchange = (args) => _this.voucherAmountCur_OnChanged(i, args);

    }
  }

  private postingGridLastRow(voucher: VoucherViewDto): PostingViewDto {
    let posting: PostingViewDto = null;
    if (this.postingDtoList) {
      this.postingDtoList.forEach(row => { if (row.voucherId == voucher.id && (!posting || row.lineNum > posting.lineNum)) { posting = row; } });
    }
    return posting;
  }

  // Posting grid toolbar
  public postingGridToolbarClick(args: ClickEventArgs) {
    switch (args.item.id) {
      case 'postingAdjustAmounts':
        this.postingAdjustAmountsConfirm();
        break;
      case 'postingDelete':
        if (this.postingGrid.editSettings.allowDeleting) {
          if (this.postingGrid.isEdit) {
            var dto: PostingViewDto = <PostingViewDto>this.postingGrid.editModule.editModule.previousData;
            if (dto?.id != null) {
              var rowIdx = this.gridGetRowIdxById(this.postingGrid, dto.id);
              this.gridDeferRequestType(this.postingGrid, { requestType: 'delete', rowIndex: rowIdx }, true);
            }
            this.gridCancelledConfirmed = this.postingGrid;
            this.postingGrid.closeEdit(); //cancel the edit 
          }
          else {
            var dtos: any[] = this.postingGrid.getSelectedRecords();
            if (dtos?.length > 0) {
              this.postingGrid.deleteRecord(dtos[0]); //delete the record
            }
          }
        }
        break;
      case 'postingAdd':
        if (this.postingGrid.editSettings.allowAdding) {
          if (this.postingGrid.isEdit) {
            this.gridDeferRequestType(this.postingGrid, { requestType: 'add', rowIndex: -1 }, false);
            //this.gridEditSaveCancel(this.postingGrid, false, true); //save or cancel the edit 
          }
          else {
            this.postingGrid.addRecord(); // add an empty record
          }
        }
        break;
    }
  }

  public postingGridContextMenuClick(args: ContextMenuClickEventArgs) {

    switch (args.item.id) {
      case 'gridColumnGroup':
        var columnName = <string>args.column.field;
        if (columnName) {
          this.postingGrid.groupColumn(columnName);
          this.postingGrid.groupSettings.showDropArea = true;
        }
        break;
      case 'gridColumnUnGroup':
        this.postingGrid.ungroupColumn('voucherId');
        this.postingGrid.groupSettings.showDropArea = false;
        break;
      case 'gridColumnHide':
        var columnName = args.column.field;
        if (columnName) {
          this.postingGrid.hideColumns(columnName, 'field');
        }
        break;
      case 'gridColumnsChoose':
        this.postingGrid.openColumnChooser();
        break;
      case 'gridExcelExport':
        this.postingGrid.excelExport(<ExcelExportProperties>{ fileName: this.routerShortUrl() + '.xlsx' });
        break;
    }
  }

  // Currency editor setup
  private currencyEditCellSetup() {
    var _this = this;
    this.currencyEditCell = {
      create: () => {
        _this.currencyDdlElement = document.createElement('input');
        return _this.currencyDdlElement;
      },
      read: () => {
        return _this.currencyDdl.value;
      },
      destroy: () => {
        if (_this.currencyDdl) {
          _this.currencyDdl.destroy();
          _this.currencyDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        this.currencyDdl = new CerDropDownList({
          fields: { text: 'num', value: 'id' },
          placeholder: 'Vælg valuta',
          popupWidth: '200px',
          allowFiltering: true,
          dataSource: new DataManager(_this.currencies),
          change: (args: ChangeEventArgs) => { _this.currencyIdChanged(args); },
        });
        var voucherDto = <VoucherViewDto>args.rowData;
        this.currencyDdl.value = voucherDto.currency;
        this.currencyDdl.appendTo(_this.currencyDdlElement);
      }
    };
  }

  // Approver editor setup
  private approverEditCellSetup() {
    var _this = this;
    this.approverEditCell = {
      create: () => {
        _this.approverDdlElement = document.createElement('input');
        return _this.approverDdlElement;
      },
      read: () => {
        return _this.approverDdl.value;
      },
      destroy: () => {
        if (_this.approverDdl) {
          _this.approverDdl.destroy();
          _this.approverDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.approverDdl = new CerDropDownList({
          placeholder: 'Vælg godkender',
          fields: { text: 'shortName', value: 'id' },
          popupWidth: '200px',
          popupHeight: '400px',
          columns: [
            { field: 'shortName', headerText: 'Navn', width: '180px', searchOperator: 'StartsWith', allowFiltering: true }
          ],
          allowFiltering: true,
          dataSource: _this.usersDM,
          showPopupDisableForEnterWhenHasValue: true
          //change: (args: ChangeEventArgs) => { this.approverIdChanged(args); },
        });
        var voucherDto = <VoucherViewDto>args.rowData;
        this.approverDdl.value = voucherDto.approver;
        this.approverDdl.appendTo(this.approverDdlElement);
      }
    };
  }

  // Posting type editor setup
  private postingTypeEditCellSetup() {
    var _this = this;
    this.postingTypeEditCell = {
      create: () => {
        _this.postingTypeDdlElement = document.createElement('input');
        return _this.postingTypeDdlElement;
      },
      read: () => {
        return _this.postingTypeDdl.value;
      },
      destroy: () => {
        if (_this.postingTypeDdl) {
          _this.postingTypeDdl.destroy();
          _this.postingTypeDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.postingTypeDdl = new CerDropDownList({
          placeholder: 'Vælg type',
          fields: { text: 'name', value: 'id' },
          popupWidth: '140px',
          popupHeight: '300px',
          columns: [
            { field: 'name', headerText: 'Type', width: '120px', searchOperator: 'StartsWith', allowFiltering: true }
          ],
          allowFiltering: true,
          dataSource: new DataManager(this.postingTypes),
          change: (args: ChangeEventArgs) => { _this.postingTypeChanged(args); },
        });
        var data = <PostingViewDto>args.rowData;
        _this.postingTypeDdl.value = data.postingType;
        _this.postingTypeDdl.appendTo(_this.postingTypeDdlElement);
      }
    };
  }

  // Project cost type editor setup
  private projectCostTypeEditCellSetup() {
    var _this = this;
    this.projectCostTypeEditCell = {
      create: () => {
        _this.projectCostTypeDdlElement = document.createElement('input');
        return _this.projectCostTypeDdlElement;
      },
      read: () => {
        return _this.projectCostTypeDdl.value;
      },
      destroy: () => {
        if (_this.projectCostTypeDdl) {
          _this.projectCostTypeDdl.destroy();
          _this.projectCostTypeDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.projectCostTypeDdl = new CerDropDownList({
          placeholder: 'Vælg art',
          fields: { text: 'description', value: 'num' },
          popupHeight: '300px',
          popupWidth: '300px',
          filterType: 'StartsWith',
          columns: [
            { field: 'num', headerText: 'Art', width: '40px', searchOperator: 'StartsWith', allowFiltering: true },
            { field: 'name', headerText: 'Navn', width: '240px', searchOperator: 'Contains', allowFiltering: true }
          ],
          allowFiltering: true,
          dataSource: new DataManager(_this.projectCostTypesFiltered),
          showClearButton: true,
          change: (args: ChangeEventArgs) => { _this.projectCostTypeChanged(args); },
        });
        var data = <PostingViewDto>args.rowData;
        _this.projectCostTypeDdl.value = data.projectCostType;
        _this.projectCostTypeDdl.appendTo(_this.projectCostTypeDdlElement);
      }
    };
  }

  // Tax code editor setup
  private taxCodeEditCellSetup() {
    var _this = this;
    this.taxCodeEditCell = {
      create: () => {
        _this.taxCodeDdlElement = document.createElement('input');
        return _this.taxCodeDdlElement;
      },
      read: () => {
        return _this.taxCodeDdl.value;
      },
      destroy: () => {
        if (_this.taxCodeDdl) {
          _this.taxCodeDdl.destroy();
          _this.taxCodeDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.taxCodeDdl = new CerDropDownList({
          placeholder: 'Vælg momskode',
          fields: { text: 'num', value: 'num' },
          popupHeight: '360px',
          popupWidth: '300px',
          showClearButton: true,
          columns: [
            { field: 'num', headerText: 'Kode', width: '80px', searchOperator: 'StartsWith', allowFiltering: true },
            { field: 'name', headerText: 'Navn', width: '200px', searchOperator: 'StartsWith', allowFiltering: true }
          ],
          allowFiltering: true,
          dataSource: _this.taxCodesDM,
          change: (args: ChangeEventArgs) => { _this.taxCodeChanged(args); },
        });
        var data = <PostingViewDto>args.rowData;
        _this.taxCodeDdl.value = data.taxCode;
        _this.taxCodeDdl.appendTo(_this.taxCodeDdlElement);
      }
    };
  }

  public taxCodeChanged(args: any) {
    if (args.itemData) {
      var data = this.gridCurrentEditDtoGet(this.postingGrid);
    }
  }

  // Tax code editor setup
  private ledgerDimensionEditCellSetup() {
    var _this = this;
    this.ledgerDimensionEditCell = {
      create: () => {
        _this.ledgerDimensionDdlElement = document.createElement('input');
        return _this.ledgerDimensionDdlElement;
      },
      read: () => {
        return _this.ledgerDimensionDdl.value;
      },
      destroy: () => {
        if (_this.ledgerDimensionDdl) {
          _this.ledgerDimensionDdl.destroy();
          _this.ledgerDimensionDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.ledgerDimensionDdl = new CerDropDownList({
          placeholder: 'Vælg afdeling',
          fields: { text: 'num', value: 'num' },
          popupHeight: '360px',
          popupWidth: '300px',
          showClearButton: true,
          columns: [
            { field: 'num', headerText: 'Kode', width: '80px', searchOperator: 'StartsWith', allowFiltering: true },
            { field: 'name', headerText: 'Navn', width: '200px', searchOperator: 'StartsWith', allowFiltering: true }
          ],
          allowFiltering: true,
          dataSource: _this.ledgerDimensionsDM,
          change: (args: ChangeEventArgs) => { _this.taxCodeChanged(args); },
        });
        var data = <PostingViewDto>args.rowData;
        _this.ledgerDimensionDdl.value = data.dimension;
        _this.ledgerDimensionDdl.appendTo(_this.ledgerDimensionDdlElement);
      }
    };
  }

  public postingGridInitControls() {
    var i: HTMLInputElement = this.postingGridEditFormInputElementGetByColumnName('amountCur');
    if (i) {
      this.postingAmountCurEditValue = null;
      var amount: number = this.postingDtoEdit?.amountCur;
      this.numericEditAmountCurSetup(i, amount);
      var _this = this;
      i.onchange = (args) => _this.postingAmountCur_OnChanged(i, args);
      i.onblur = (args) => _this.postingAmountCur_OnChanged(i, args);
      i.focus();
    }
  }

  private numericEditAmountCurSetup(i: HTMLInputElement, amount: number, useSteps: boolean = true) {
    var ctrl: NumericTextBox = (<any>i).ej2_instances[0];
    if (ctrl) {
      ctrl.showSpinButton = false;
      if (this.detailsVm.amountCurOptions?.length > 0 && useSteps) {
        if (i.parentElement) {
          Array.from(i.parentElement.children).forEach(c => { if (c.classList.toString().includes('e-spin-')) { c.remove() } }); // Remove any existing children
          i.parentElement.classList.add('e-input-group-hide-border');
        }
        if (ctrl.value == 0) {
          ctrl.value = null; // Reset value to allow selection
        }
        var ctrlAny = <any>ctrl;
        ctrlAny.steps = this.detailsVm.amountCurOptions;
        ctrlAny.performAction = this.amountCurPerformAction;
        let nFormatter: Function = new Internationalization().getNumberFormat({ skeleton: 'N2', useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 });
        let amountFmt: string = amount ? nFormatter(amount) : null;
        let dataNum: number[] = this.detailsVm.amountCurOptions;
        dataNum = dataNum.concat(dataNum.map((option: number) => -option));
        dataNum.sort((n1, n2) => n2 - n1);
        let data: string[] = dataNum.map((option: number) => nFormatter(option))
        let comboBoxObj = new ComboBox({
          dataSource: data,
          autofill: false,
          allowCustom: true,
          placeholder: "Vælg beløb",
          value: amountFmt,
          popupHeight: '200px'
        });
        comboBoxObj.appendTo(i);
        if (i.parentElement) {
          //i.parentElement.style.border = 'none';
        }
      }
    }
  }

  public amountCurPerformAction(value: number, step: number, operation: string) {
    if (value === null || isNaN(value)) {
      value = 0;
    }
    var _this: any = this;
    var _steps: number[] = _this.steps;
    var isIncrement: boolean = operation === 'increment';
    var nextSteps: number[] = isIncrement ? _steps.filter(step => step > value) : _steps.slice().reverse().filter(step => step < value);
    var updatedValue: number = (nextSteps.length > 0) ? nextSteps[0] : (isIncrement ? _steps[0] : _steps[_steps.length - 1]);
    return _this.strictMode ? _this.trimValue(updatedValue) : updatedValue;
  }


  private postingAmountCur_OnChanged(i: HTMLInputElement, args: any) {
    var editData = this.gridCurrentEditDtoGet(this.postingGrid);
    if (editData) {
      var numTextBox: NumericTextBox = (<any>i).ej2_instances[0];
      editData.amountCur = numTextBox.value;
      this.postingAmountCurEditValue = editData.amountCur;
      this.postingValidateRoyalty(editData);
      this.voucherCanApproveByPostingEditCalc(editData);
    }
  }

  public postingGridUpdateDesign(data: PostingViewDto) {
    let project: boolean = this.voucherService.isPostingTypeProject(data.postingType);
    let vendor: boolean = this.voucherService.isPostingTypeVendor(data.postingType);

    this.postingGridEditFormInputElementDisable('paymentRef', !vendor);
    this.postingGridEditFormInputElementDisable('projectCostType', !project);
    this.postingGridEditFormInputElementDisable('projectLedgerNum', !project);

    if (this.projectCostTypeDdlElement && this.projectCostTypeDdl) {
      this.projectCostTypeDdlElement.disabled = !project;
      this.projectCostTypeDdl.enabled = project;
      this.projectCostTypeDdl.placeholder = project ? 'Vælg art' : '';
    }
    if (this.projectLedgerNumDdlElement && this.projectLedgerNumDdl) {
      this.projectLedgerNumDdlElement.disabled = !project;
      this.projectLedgerNumDdl.enabled = project;
      this.projectLedgerNumDdl.placeholder = project ? 'Vælg finanskonto' : '';
    }
  }

  public postingTypeChanged(args: any) {
    if (args.itemData) {
      var data: PostingViewDto = this.gridCurrentEditDtoGet(this.postingGrid);
      data.postingType = args.itemData.id;
      data.postingTypeName = args.itemData.description;
      this.postingAccountClear(data);
      this.postingGridUpdateDesign(data);
      this.accountNumDdlSetup(data);
    }
  }

  public postingValidateRoyalty(editData: any) {
    if (editData.amountCur && editData.postingType == <number>VoucherPostingTypeEnum.ProjectRoyalty) {
      //  this.showRoyaltyInfo();
    }
  }

  private showRoyaltyInfo() {

    var vendorAccountNum = "ttt";
    this.ui.confirm(
      "Royalty faktura for kreditor " + vendorAccountNum,
      "Royaltyfaktura")
      .then(action => { });
  }

  public postingAccountClear(dto: PostingViewDto) {
    dto.accountNum = "";
    dto.accountDescription = null;
    dto.projectCostType = null;
    dto.projectLedgerNum = null
    dto.taxCode = null;
    dto.vendorBankAccount = '';

    this.postingGridEditFormInputElementSetValue('accountNum', dto.accountNum);
    this.postingGridEditFormInputElementSetValue('accountDescription', dto.accountDescription);
    this.postingGridEditFormInputElementSetValue('projectCostType', dto.projectCostType);
    this.postingGridEditFormInputElementSetValue('projectLedgerNum', dto.projectLedgerNum);
    this.postingGridEditFormInputElementSetValue('taxCode', dto.taxCode, dto.taxCode);
    this.postingGridEditFormInputElementSetValue('vendorBankAccount', dto.vendorBankAccount);
    this.voucherCanApproveByPostingEditCalc();
  }

  public projectCostTypeChanged(args: any) {
    if (args.itemData) {
      var data = null;
      if (this.voucherGrid.isEdit) {
        data = this.gridCurrentEditDtoGet(this.voucherGrid);
        this.setProjectPostingDataProforma(null, data);
      }
      else {
        data = this.gridCurrentEditDtoGet(this.postingGrid);
        data.projectLedgerNum = '';
        this.postingGridEditFormInputElementSetValue('projectLedgerNum', data.projectLedgerNum);
        //this.postingGridUpdateDesign(data);
        //if (this.isExpenseVoucher) {
        this.projectLedgerNumDdlSetup(data);
        //}
      }
    }
    this.voucherCanApproveByPostingEditCalc();
  }

  // Project ledger num editor setup
  private projectLedgerNumEditCellSetup() {
    // Account num dropdown
    var _this = this;
    this.projectLedgerNumEditCell = {
      create: () => {
        _this.projectLedgerNumDdlElement = document.createElement('input');
        return _this.projectLedgerNumDdlElement;
      },
      read: () => {
        return _this.projectLedgerNumDdl.value;
      },
      destroy: () => {
        if (_this.projectLedgerNumDdl) {
          _this.projectLedgerNumDdl.destroy();
          _this.projectLedgerNumDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.projectLedgerNumDdlSetup(<PostingViewDto>args.rowData);
      }
    };
  }

  // Project ledger num  editor setup
  private projectLedgerNumDdlSetup(dto: PostingViewDto) {
    let col: Column = this.postingGrid.getColumnByField('projectLedgerNum');
    if (col /*&& col.allowEditing*/ && col.visible) {
      var isCreate: boolean = (this.projectLedgerNumDdl == null);

      if (isCreate) {
        // Project ledger num dropdown create with params
        var _this = this;
        this.projectLedgerNumDdl = new CerDropDownList({
          placeholder: 'Vælg finanskonto',
          fields: { text: 'num', value: 'num' },
          popupWidth: '500px',
          popupHeight: '300px',
          showClearButton: true,
          columns: [
            { field: 'num', headerText: 'Konto', width: '60px', searchOperator: 'StartsWith', allowFiltering: true },
            { field: 'description', headerText: 'Navn', width: '420px', searchOperator: 'Contains', allowFiltering: true }],
          allowFiltering: true,
          ignoreAccent: true,
          change: (args: ChangeEventArgs) => { _this.projectLedgerNumChanged(args); }
        });
        this.projectLedgerNumDdl.enabled = col.allowEditing;
      }

      if (this.isExpenseVoucher) {
        if (isCreate) {
          this.projectLedgerNumDdl.dataSource = new DataManager(this.ledgerAccounts);
          this.projectLedgerNumDdl.query = new Query();
        }
      }
      else {
        // VendorVoucher: Needs research based on cost type
        this.projectLedgerNumDdl.dataSource = new DataManager(this.projectLedgerAccounts);
        if (dto?.projectCostType) {
          this.projectLedgerNumDdl.baseQuery = new Query().where('projCostType', 'equal', dto.projectCostType);
        } else {
          this.projectLedgerNumDdl.baseQuery = new Query();
        }
      }
      this.projectLedgerNumDdl.value = dto?.projectLedgerNum;

      if (isCreate) {
        this.projectLedgerNumDdl.appendTo(this.projectLedgerNumDdlElement);
      }
    }
  }

  public projectLedgerNumChanged(args: any) {
    var data: PostingViewDto = this.gridCurrentEditDtoGet(this.postingGrid);
    data.taxCode = args.itemData?.taxCode ?? null;
    if (data.taxCode == '') {
      data.taxCode = null;
    }
    this.
      postingGridEditFormInputElementSetValue('taxCode', data.taxCode, data.taxCode);
    this.voucherCanApproveByPostingEditCalc();
  }

  // Account num editor setup
  private accountNumEditCellSetup() {
    // Account num dropdown
    var _this = this;
    this.accountNumEditCell = {
      create: () => {
        _this.accountNumDdlElement = document.createElement('input');
        return this.accountNumDdlElement;
      },
      read: () => {
        return _this.accountNumDdl.value;
      },
      destroy: () => {
        if (_this.accountNumDdl) {
          _this.accountNumDdlDestroy(_this.accountNumDdl, null);
          _this.accountNumDdl.destroy();
          _this.accountNumDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        _this.accountNumDdlSetup(<PostingViewDto>args.rowData);
      }
    };
  }

  public voucherVendorAccountNumEditCellSetup() {
    // Voucher Vendor Account num dropdown
    if (this.userIsAdmin || this.voucherIsStatusCreated) {
      var _this = this;
      this.voucherVendorAccountNumEditCell = {
        create: () => {
          _this.voucherVendorAccountNumDdlElement = document.createElement('input');
          return _this.voucherVendorAccountNumDdlElement;
        },
        read: () => {
          return _this.voucherVendorAccountNumDdl.value;
        },
        destroy: () => {
          if (_this.voucherVendorAccountNumDdl) {
            _this.accountNumDdlDestroy(_this.voucherVendorAccountNumDdl, VoucherPostingTypeEnum.Vendor);
            _this.voucherVendorAccountNumDdl.destroy();
            _this.voucherVendorAccountNumDdl = null;
          }
        },
        write: (args: { rowData: Object, column: Column }) => {
          var isCreate: boolean = (!_this.voucherVendorAccountNumDdl);
          if (isCreate) {
            _this.voucherVendorAccountNumDdl = _this.accountNumDdlCreate(VoucherPostingTypeEnum.Vendor);
          }
          _this.voucherVendorAccountNumDdl.placeholder = 'Vælg kreditor';
          var list: any[] = _this.getLookupDefaultListForAccountNum(VoucherPostingTypeEnum.Vendor).slice(); // Clone from read-only list
          var voucherDto: VoucherViewDto = <VoucherViewDto>args.rowData;
          _this.accountNumListAddDefaultFromDto(list, VoucherPostingTypeEnum.Vendor, true, null, voucherDto);
          _this.voucherVendorAccountNumDdl.dataSource = new DataManager(list);
          if (_this.isPostingTypeVendor(voucherDto?.balancePostingType)) {
            _this.voucherVendorAccountNumDdl.value = voucherDto.balanceAccountNum;
          }
          if (isCreate) {
            _this.voucherVendorAccountNumDdl.appendTo(_this.voucherVendorAccountNumDdlElement);
          }
        }
      }
    }
  }

  public voucherProjectNumEditCellSetup() {
    // Voucher Project num dropdown
    var _this = this;
    this.voucherProjectNumEditCell = {
      create: () => {
        _this.voucherProjectNumDdlElement = document.createElement('input');
        return _this.voucherProjectNumDdlElement;
      },
      read: () => {
        return _this.voucherProjectNumDdl.value;
      },
      destroy: () => {
        if (_this.voucherProjectNumDdl) {
          _this.accountNumDdlDestroy(_this.voucherProjectNumDdl, VoucherPostingTypeEnum.Vendor);
          _this.voucherProjectNumDdl.destroy();
          _this.voucherProjectNumDdl = null;
        }
      },
      write: (args: { rowData: Object, column: Column }) => {
        var isCreate: boolean = (!_this.voucherProjectNumDdl);
        if (isCreate) {
          _this.voucherProjectNumDdl = _this.accountNumDdlCreate(VoucherPostingTypeEnum.Project);
        }
        _this.voucherProjectNumDdl.placeholder = 'Vælg projekt';
        var list: any[] = _this.getLookupDefaultListForAccountNum(VoucherPostingTypeEnum.Project).slice(); // Clone from read-only list
        var voucherDto: VoucherViewDto = <VoucherViewDto>args.rowData;
        _this.accountNumListAddDefaultFromDto(list, VoucherPostingTypeEnum.Project, true, null, voucherDto);
        _this.voucherProjectNumDdl.dataSource = new DataManager(list);
        if (_this.isPostingTypeProject(voucherDto?.costPostingType)) {
          _this.voucherProjectNumDdl.value = voucherDto.costAccountNum;
        }
        if (isCreate) {
          _this.voucherProjectNumDdl.appendTo(_this.voucherProjectNumDdlElement);
        }
      }
    };
  }

  public accountNumDdlCreate(postingType: VoucherPostingTypeEnum): CerDropDownList {

    // Voucher account num dropdown create with common params
    var options: any =
    {
      fields: { text: 'num', value: 'num' },
      popupWidth: '600px',
      popupHeight: '360px',
      showClearButton: true,
      columns: [
        { field: 'num', headerText: 'Nummer', width: '100px', filterType: 'StartsWith' },
        { field: 'description', headerText: 'Navn', width: '480px', filterType: 'Contains' }
      ],
      allowFiltering: true,
      autoBuildQuery: false,
      filterRunDelay: 500
    };

    /*
    if (postingType == VoucherPostingTypeEnum.Vendor) {
      options.footerTemplate =
        `<div class="e-toolbar e-toolbar-strip" role="toolbar">
<div class="e-toolbar-items e-tbar-pos">
<div class="e-toolbar-right">
<div class="e-toolbar-item" title="Ny post">
<button class="e-tbar-btn e-tbtn-txt e-control e-btn e-lib" type="button" action="add" id="buttonCreate"
data-ripple="true" tabindex="0" data-tabindex="0" aria-disabled="false" aria-label="Ny post">
<span class="e-btn-icon e-icons e-add e-icon-left"></span>
<span class="e-tbar-btn-text">Ny post</span></button>
</div></div></div></div>`;
    }
*/
    
    var ddl: CerDropDownList = new CerDropDownList(options);

    var _this = this;
    //ddl.addEventListener('actionBegin', (args: object) => {
    //  _this.accountNumActionBegin(args, postingType, ddl);
    //});
    ddl.addEventListener('actionComplete', (args: object) => {
      _this.accountNumActionComplete(args, postingType, ddl);
    });
    ddl.addEventListener('actionFailure', (args: object) => {
      _this.accountNumActionFailure(args);
    });
    ddl.addEventListener('change', (args: ChangeEventArgs) => {
      _this.accountNumChanged(args, postingType);
    });
    ddl.addEventListener('filtering', (args: FilteringEventArgs) => {
      _this.accountNumFilter(args, postingType, ddl);
    });
    ddl.addEventListener('footerClick', (args: any) => {
      _this.accountNumFooterClick(args, postingType, ddl);
    });
    return ddl;
  }

  public accountNumFooterClick(args: any, postingType: VoucherPostingTypeEnum, ddl: CerDropDownList) {
    console.log('Footer clicked ', args);
    if (args.srcElement) {
      var btn: any = parentsUntil(args.srcElement, 'e-tbar-btn');
      var action = btn?.getAttribute('action');
      switch (action) {
        case 'add':
          this.voucherCreateAccountDialog(postingType);
          break;
        default:
          console.log('Unknown footer action ', action);
          break;
      }
    }
  }

  public accountNumDdlDestroy(ddl: CerDropDownList, postingType: VoucherPostingTypeEnum) {
    var _this = this;
    ddl.removeEventListener('footerClick', (args: any) => {
      _this.accountNumFooterClick(args, postingType, ddl);
    });
    ddl.removeEventListener('filtering', (args: FilteringEventArgs) => {
      _this.accountNumFilter(args, postingType, ddl);
    });
    ddl.removeEventListener('change', (args: ChangeEventArgs) => {
      _this.accountNumChanged(args, postingType);
    });
    ddl.removeEventListener('actionFailure', (args: object) => {
      _this.accountNumActionFailure(args);
    });
    ddl.removeEventListener('actionComplete', (args: object) => {
      _this.accountNumActionComplete(args, postingType, ddl);
    });
    //ddl.removeEventListener('actionBegin', (args: object) => {
    //  _this.accountNumActionBegin(args, postingType, ddl);
    //});
  }

  public accountNumDdlSetup(postingDto: PostingViewDto) {
    var isCreate: boolean = (!this.accountNumDdl);

    if (isCreate) {
      // Account num dropdown create with common params
      this.accountNumDdl = this.accountNumDdlCreate(null);
    }
    else {
      // DDL already setup with the correct type?
      var postingType = (<any>this.accountNumDdl).postingType;
      if (postingDto.postingType == postingType) {
        return;
      }
    }

    switch (<VoucherPostingTypeEnum>postingDto.postingType) {
      case VoucherPostingTypeEnum.Vendor:
        // Vendor dropdown
        this.accountNumEditDdlCurrentTableName = 'data/VendorView';
        this.accountNumDdl.placeholder = 'Vælg kreditor';
        this.accountNumFilterDefaultListData = this.vendorsDefault;
        break;
      case VoucherPostingTypeEnum.Project:
        // Project dropdown
        this.accountNumEditDdlCurrentTableName = 'project';
        this.accountNumDdl.placeholder = 'Vælg projekt';
        this.accountNumFilterDefaultListData = this.projectsDefault;
        break;
      case VoucherPostingTypeEnum.ProjectRoyalty:
        // Project royalty dropdown
        this.accountNumEditDdlCurrentTableName = 'project';
        this.accountNumDdl.placeholder = 'Vælg projekt';
        this.accountNumFilterDefaultListData = this.projectsDefault;
        break;
      case VoucherPostingTypeEnum.Ledger:
        // Ledger account dropdown
        this.accountNumEditDdlCurrentTableName = 'financeLedgerAccount';
        this.accountNumDdl.placeholder = 'Vælg finanskonto';
        this.accountNumFilterDefaultListData = this.ledgerAccounts;
        break;
      case VoucherPostingTypeEnum.Debtor:
        // Debtor dropdown
        this.accountNumEditDdlCurrentTableName = 'debtor';
        this.accountNumDdl.placeholder = 'Vælg debitor';
        this.accountNumFilterDefaultListData = this.debtorsDefault;
        break;
      case VoucherPostingTypeEnum.Bank:
        // Debtor dropdown
        this.accountNumEditDdlCurrentTableName = 'data/BankAccount';
        this.accountNumDdl.placeholder = 'Vælg bankkonto';
        this.accountNumFilterDefaultListData = this.bankAccounts;
        break;
    }

    var list: any[] = this.accountNumFilterDefaultListData.slice(); // Clone from read-only list
    if (postingDto != null) {
      this.accountNumListAddDefaultFromDto(list, null, true, postingDto);
    }
    this.accountNumDdl.dataSource = new DataManager(list);

    this.accountNumDdl.value = postingDto.accountNum;
    //    this.accountNumDdl.query = new Query();

    if (isCreate) {
      this.accountNumDdl.appendTo(this.accountNumDdlElement);
    }
    (<any>this.accountNumDdl).postingType = postingDto.postingType;
  }

  // Filter account num dropdown
  public accountNumFilter(args: FilteringEventArgs, postingType: VoucherPostingTypeEnum, ddl: CerDropDownList) {
    var filterText: string = args.text;
    if (!filterText) {
      var listData: any[] = [...this.getLookupDefaultListForAccountNum(postingType)]; // Clone from read-only list
      this.accountNumListAddDefaultFromDto(listData, postingType, true);
      args.updateData(new DataManager(listData));
    }
    else {
      var query: Query = new Query().from(this.getLookupTableNameForAccountNum(postingType)).take(50);
      var filterField = '$txt';
      query = query.where(new Predicate(filterField, 'contains', filterText, true));
      (query as any).filterActiveText = filterText;
      args.updateData(this.apiDataManager(), query);
    }
  }


  private getLookupDefaultListForAccountNum(postingType: VoucherPostingTypeEnum): object[] {
    var table: object[];

    switch (postingType) {
      case VoucherPostingTypeEnum.Vendor:
        table = this.vendorsDefault;
        break;
      case VoucherPostingTypeEnum.Project:
      case VoucherPostingTypeEnum.ProjectRoyalty:
        table = this.projectsDefault;
        break;
      default:
        table = this.accountNumFilterDefaultListData;
    }
    return table;
  }

  private getLookupTableNameForAccountNum(postingType: VoucherPostingTypeEnum): string {
    var tableName: string = '';

    switch (postingType) {
      case VoucherPostingTypeEnum.Vendor:
        tableName = 'data/VendorView';
        break;
      case VoucherPostingTypeEnum.Project:
      case VoucherPostingTypeEnum.ProjectRoyalty:
        tableName = 'project';
        break;
      default:
        tableName = this.accountNumEditDdlCurrentTableName;
    }
    return tableName;
  }

  private postingGridEditFormInputElementGetByColumnName(columnName: string): HTMLInputElement {
    return <HTMLInputElement>this.gridEditFormElementGet(this.postingGrid).querySelector("#PostingGrid" + columnName);
  }

  private postingGridEditFormInputElementDisable(columnName: string, value: boolean) {
    var i: HTMLInputElement = this.postingGridEditFormInputElementGetByColumnName(columnName);
    if (i) {
      i.disabled = value;
    }
  }

  private postingGridEditFormInputElementSetValue(columnName: string, value: string, id: any = null) {
    var i: HTMLInputElement = this.postingGridEditFormInputElementGetByColumnName(columnName);
    if (i) {
      i.value = value;
      if (i) {
        this.setDropDownListId(i, id);
      }
    }
  }

  private voucherGridEditFormInputElementGetByColumnName(columnName: string): HTMLInputElement {
    return <HTMLInputElement>this.gridEditFormElementGet(this.voucherGrid).querySelector("#VoucherGrid" + columnName);
  }

  private voucherGridEditFormInputElementDisable(columnName: string, value: boolean) {
    var i: HTMLInputElement = this.voucherGridEditFormInputElementGetByColumnName(columnName);
    if (i) {
      i.disabled = value;
    }
  }

  private voucherGridEditFormInputElementSetValue(columnName: string, value: string, id: any = null) {
    var i: HTMLInputElement = this.voucherGridEditFormInputElementGetByColumnName(columnName);
    if (i) {
      i.value = value;
      if (id) {
        this.setDropDownListId(i, id);
      }
    }
  }

  private setDropDownListId(i: HTMLInputElement, id: any) {
    var ej2: any = i;
    if (ej2.ej2_instances) {
      var ej2 = ej2.ej2_instances[0];
      if (ej2 instanceof DropDownList) {
        var ddl: DropDownList = <DropDownList>ej2;
        ddl.value = id;
      }
    }
  }

  // Account num drop down data returned to list
  private accountNumListAddDefaultFromDto(listData: any[], fixedType: VoucherPostingTypeEnum, addToStart: boolean = false, postingDto: PostingViewDto = null, voucherDto: VoucherViewDto = null) {
    addToStart = false;
    switch (fixedType) {
      case VoucherPostingTypeEnum.Vendor:
        var voucherData: VoucherViewDto = voucherDto ?? this.gridCurrentEditDtoGet(this.voucherGrid);

        if (voucherData?.balanceAccountNum && this.isPostingTypeVendor(voucherData.balancePostingType)) {
          if (listData.filter((r: any) => r.num == voucherData.balanceAccountNum).length == 0) {
            var vendorDefault: VendorViewDto[] = this.vendorsDefault.filter(v => v.num == voucherData.balanceAccountNum);
            if (vendorDefault.length >= 1) {
              var vAdd: VendorViewDto = Object.assign({}, vendorDefault[0]);
              if (addToStart) {
                listData.unshift(vAdd);
              }
              else {
                listData.push(vAdd);
              }
            }
          }
        }
        break;
      case VoucherPostingTypeEnum.Project:
      case VoucherPostingTypeEnum.ProjectRoyalty:
        var voucherData: VoucherViewDto = voucherDto ?? this.gridCurrentEditDtoGet(this.voucherGrid);
        if (voucherData?.costAccountNum && this.isPostingTypeProject(voucherData.costPostingType)) {
          if (listData.filter((r: any) => r.num == voucherData.costAccountNum).length == 0) {
            var projectDefault: ProjectDto[] = this.projectsDefault.filter(v => v.num == voucherData.costAccountNum);
            if (projectDefault.length >= 1) {
              var pAdd: ProjectDto = Object.assign({}, projectDefault[0]);
              if (addToStart) {
                listData.unshift(pAdd);
              }
              else {
                listData.push(pAdd);
              }
            }
          }
        }
        break;
      default:
        this.accountNumListAddDefaultFromPostingDto(listData, addToStart, postingDto);
    }
  }

  private accountNumListAddDefaultFromPostingDto(listData: any[], addToStart: boolean = false, postingDto: PostingViewDto = null) {
    var postingData: PostingViewDto = postingDto ?? <PostingViewDto>this.gridCurrentEditDtoGet(this.postingGrid);
    if (postingData && postingData.accountNum) {
      if (listData.filter((r: any) => r.num == postingData.accountNum).length == 0) {
        var postingType: VoucherPostingTypeEnum = this.voucherService.postingTypeEnum(postingData.postingType);
        switch (postingType) {
          case VoucherPostingTypeEnum.Vendor:
            var v = new VendorViewDto();
            v.num = postingData.accountNum;
            v.description = postingData.accountDescription;
            if (addToStart) {
              listData.unshift(v);
            }
            else {
              listData.push(v);
            }
            break;
          case VoucherPostingTypeEnum.Project:
          case VoucherPostingTypeEnum.ProjectRoyalty:
            var p = new ProjectDto();
            p.num = postingData.accountNum;
            p.description = postingData.accountDescription;
            if (addToStart) {
              listData.unshift(p);
            }
            else {
              listData.push(p);
            }
            break;
          case VoucherPostingTypeEnum.Ledger:
            var f = new FinanceLedgerAccountDto();
            f.num = postingData.accountNum;
            f.description = postingData.accountDescription;
            if (addToStart) {
              listData.unshift(f);
            }
            else {
              listData.push(f);
            }
            break;
          case VoucherPostingTypeEnum.Debtor:
            var d = new DebtorDto();
            d.num = postingData.accountNum;
            d.description = postingData.accountDescription;
            if (addToStart) {
              listData.unshift(d);
            }
            else {
              listData.push(d);
            }
            break;
        }
      }
    }
  }

  private accountNumActionComplete(e: any, postingType: VoucherPostingTypeEnum, ddl: CerDropDownList): void {
    this.accountNumListAddDefaultFromDto(e.result, postingType);
  }

  // Account num drop down data returned to list
  public accountNumActionFailure(e: any): void {
    this.ui.errorApi(e.error);
    console.log("Kontering liste fejlede");
    console.log(e);
  }


  public accountNumChanged(args: any, postingTypeFixed: VoucherPostingTypeEnum) {
    // Reset account num DDL state
    if (args.itemData && args.element) {
      let data = args.itemData;
      if (data) {
        switch (postingTypeFixed) {
          case VoucherPostingTypeEnum.Vendor:
            if (!this.vendorsDefault.find(d => d.num == data.num)) {
              var vAdd: VendorViewDto = Object.assign({}, data);
              this.vendorsDefault.push(vAdd);
            }
            this.accountNumChangeSyncVoucherGrid(data.nameCurrency, data.currency, null, postingTypeFixed, true);
            this.setVendorPostingDataProforma(data);
            this.setFromName(data);
            break;
          case VoucherPostingTypeEnum.Project:
            if (this.projectsDefault.filter(d => d.num == data.num).length == 0) {
              var pAdd: ProjectDto = Object.assign({}, data);
              this.projectsDefault.push(pAdd);
            }
            this.accountNumChangeSyncVoucherGrid(data.description, data.currency, data.responsible, postingTypeFixed, true);
            this.setProjectPostingDataProforma(data);
            break;
          default:
            var dto: PostingViewDto = this.gridCurrentEditDtoGet(this.postingGrid);
            var responsible: string = null;
            var valid: boolean = true;
            if (dto) {
              switch (dto.postingType) {
                case VoucherPostingTypeEnum.Vendor:
                case VoucherPostingTypeEnum.Debtor:
                  if (data.currency && !this.validateFieldCurrency(data.currency, this.getSelectedVoucher())) {
                    this.postingAccountClear(dto);
                    args.value = '';
                    valid = false;
                  }
                  this.setFromName(data);
                  break;
                case VoucherPostingTypeEnum.Ledger:
                  if (!this.userIsAdmin) {
                    this.error("Finans anvendes kun af økonomi brugerroller");
                    args.value = dto.accountNum;
                    valid = false;
                  }
                  break;
                case VoucherPostingTypeEnum.Project:
                  responsible = data.responsible;
                  break;
              }
            }
            if (valid) {
              var force: boolean = false;
              if (this.isPostingTypeVendor(dto.postingType)) {
                dto.accountDescription = data.nameCurrency;
                dto.vendorBankAccount = data.bankAccount;
                dto.taxCode = data.taxCode;
                if (dto.taxCode == '') {
                  dto.taxCode = null;
                }
                force = true;
              }
              else {
                dto.accountDescription = data.description;
                if (this.isPostingTypeLedger(dto.postingType)) {
                  dto.taxCode = data.taxCode;
                  if (dto.taxCode == '') {
                    dto.taxCode = null;
                  }
                }
                //this.accountNumChangeSyncVoucherGrid(data.description, null, responsible, dto.postingType, force);
              }

              this.postingGridEditFormInputElementSetValue('vendorBankAccount', dto.vendorBankAccount ?? "");
              this.postingGridEditFormInputElementSetValue('accountDescription', dto.accountDescription ?? "");
              this.postingGridEditFormInputElementSetValue('taxCode', dto.taxCode, dto.taxCode);

            }
        }
      }
    }
    this.voucherCanApproveByPostingEditCalc();
  }

  private accountNumChangeSyncVoucherGrid(description: string, currencyISO: string, responsible: string, postingType: VoucherPostingTypeEnum, force: boolean) {
    var voucherDto: VoucherViewDto = this.gridCurrentEditDtoGet(this.voucherGrid);

    if (this.voucherService.isPostingTypeBalance(postingType)) {
      if (force || (!voucherDto.balancePostingType) || (voucherDto.balancePostingType === <number>postingType)) {
        voucherDto.balanceAccountDescription = description;
        this.voucherGridEditFormInputElementSetValue('balanceAccountDescription', voucherDto.balanceAccountDescription);
        if (currencyISO) {
          this.setVoucherFieldCurrencyISO(voucherDto, currencyISO);
        }
      }
    }
    else {
      if (force || (!voucherDto.costPostingType) || (voucherDto.costPostingType === <number>postingType)) {
        voucherDto.costAccountDescription = description;
        this.voucherGridEditFormInputElementSetValue('costAccountDescription', voucherDto.costAccountDescription);
        if (responsible) {
          var user: UserDto = this.usersAll.find(u => u.shortName == responsible);
          if (user) {
            user = this.userApprovalDelegateeGet(user);
            if (user.active) {
              user = this.users.find(u => u.id == user.id);
              if (user?.active) {
                voucherDto.approverName = user.name;
                voucherDto.approverShortName = user.shortName;
                voucherDto.approver = user.id;
                this.voucherGridEditFormInputElementSetValue('approverName', user.name);
                this.voucherGridEditFormInputElementSetValue('approverShortName', user.shortName);
                this.voucherGridEditFormInputElementSetValue('approver', user.shortName, user.id);
              }
            }
          }
        }
      }
    }
    return voucherDto;
  }
  
  private userApprovalDelegateeGet(user: UserDto): UserDto {
    var dto : UserApprovalDelegationDto = this.userApprovalDelegations?.find(uad => uad.user == user.id);
    return (dto != null ? this.users.find(u => u.id == dto.userDelegatee) : null) ?? user;
  }

  private setProjectPostingDataProforma(project: ProjectDto, voucher: VoucherViewDto = null) {
    if (this.postingDtoList) {
      for (var row of this.postingDtoList) {
        if (row.postingType == <number>VoucherPostingTypeEnum.Project ||
          row.postingType == <number>VoucherPostingTypeEnum.ProjectRoyalty) {
          if (this.projectPostingProformaDtoOrg == null) {
            this.projectPostingProformaDtoOrg = new PostingViewDto();
            Object.assign(this.projectPostingProformaDtoOrg, row);
          }
          if (project) {
            row.accountNum = project.num;
            row.accountDescription = project.description;
          }
          if (voucher) {
            row.projectCostType = voucher.projectCostType;
          }
          this.postingGrid.setRowData(row.id, row);
          break;
        }
      }
    }
  }

  private resetProjectPostingProforma() {
    if (this.projectPostingProformaDtoOrg && this.postingDtoList) {
      for (var row of this.postingDtoList) {
        if (row.postingType == <number>VoucherPostingTypeEnum.Project) {
          Object.assign(row, this.projectPostingProformaDtoOrg);
          this.postingGrid.setRowData(row.id, row);
          this.projectPostingProformaDtoOrg = null;
          break;
        }
      }
    }
  }

  private setVendorPostingDataProforma(vendor: VendorViewDto) {
    if (this.postingDtoList) {
      for (var row of this.postingDtoList) {
        if (this.isPostingTypeVendor(row.postingType)) {
          if (this.vendorPostingProformaDtoOrg == null) {
            this.vendorPostingProformaDtoOrg = new PostingViewDto();
            Object.assign(this.vendorPostingProformaDtoOrg, row);
          }
          row.accountNum = vendor.num;
          row.accountDescription = vendor.nameCurrency;
          row.taxCode = vendor.taxCode;
          row.vendorBankAccount = vendor.bankAccount;
          this.postingGrid.setRowData(row.id, row);
          break;
        }
      }
    }
  }

  private resetVendorPostingProforma() {
    if (this.vendorPostingProformaDtoOrg && this.postingDtoList) {
      for (var row of this.postingDtoList) {
        if (row.postingType == <number>VoucherPostingTypeEnum.Vendor) {
          Object.assign(row, this.vendorPostingProformaDtoOrg);
          this.postingGrid.setRowData(row.id, row);
          this.vendorPostingProformaDtoOrg = null;
          this.setFromName();
          break;
        }
      }
    }
  }

  private voucherAmountCur_OnChanged(i: HTMLInputElement, args: any) {
    var editData = this.gridCurrentEditDtoGet(this.voucherGrid);
    if (editData?.amountCur) {

      this.checkVoucherAmountCurForm(i, this.voucherDtoList[0]?.amountCur, editData.amountCur);
    }
  }

  private voucherAmountCurCheckTxt: string;
  private checkVoucherAmountCurForm(i: HTMLInputElement, amountCurFrom: number, amountCurTo: number) {
    if (amountCurTo && amountCurFrom != amountCurTo) {
      var formValues: number[] = this.detailsVm?.amountCurOptions;
      if (formValues?.length > 0 && !formValues.includes(Math.abs(amountCurTo))) {
        let intl: Internationalization = new Internationalization();
        let nFormatter: Function = intl.getNumberFormat({ skeleton: 'N2', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var found = '';
        formValues.forEach(c => {
          found += (found == '' ? '' : ', ') + nFormatter(c);
        });
        var txt: string = "Valgt beløb '" + nFormatter(amountCurTo) + "' er ikke fundet på fakturaformular (" + found + ")";
        if (this.voucherAmountCurCheckTxt != txt) {
          this.voucherAmountCurCheckTxt = txt;
          this.ui.info(txt, "Advarsel");
        }
      }
    }
  }

  private currencyIdChanged(args: any) {
    if (args.itemData) {
      var currencyIso: string = args.itemData.iso;
      var voucherDto: VoucherViewDto = this.gridCurrentEditDtoGet(this.voucherGrid);
      this.setVoucherFieldCurrencyISO(voucherDto, currencyIso);
    }
  }

  private currencyCheckTxt: string;
  private checkCurrrencyIsoForm(currencyIsoFrom: string, currencyIsoTo: string) {
    if (currencyIsoTo && currencyIsoFrom != currencyIsoTo) {
      var formValues: string[] = this.detailsVm?.formFieldValues?.Currency;
      if (formValues?.length > 0 && !formValues.includes(currencyIsoTo)) {
        var found = '';
        formValues.forEach(c => {
          found += (found == '' ? '' : ',') + c;
        });
        var txt: string = "Valgt valuta '" + currencyIsoTo + "' er ikke fundet på fakturaformular (" + found + ")";
        if (this.currencyCheckTxt != txt) {
          this.currencyCheckTxt = txt;
          this.ui.info(txt, "Advarsel");
        }
      }
    }
  }

  private setVoucherFieldCurrencyISO(voucherDto: VoucherViewDto, currencyISO: string) {
    if (currencyISO) {
      currencyISO = currencyISO.toUpperCase();
      var currency: CurrencyDto = this.currencies.find(c => c.num == currencyISO);
      if (!currency) {
        var currencies: CurrencyDto[] = this.currencies.filter(c => c.num.startsWith(currencyISO));
        if (currencies.length == 1) {
          currency = currencies[0];
        }
        else if (currencies.length == 0) {
          currencies = this.currencies.filter(c => c.num.includes(currencyISO));
          if (currencies.length == 1) {
            currency = currencies[0];
          }
        }
      }
      if (currency) {
        voucherDto.currency = currency.id;
        this.checkCurrrencyIsoForm(voucherDto.currencyISO, currency.num);
        voucherDto.currencyISO = currency.num;
        this.voucherGridEditFormInputElementSetValue('currency', currency.num, currency.id);
      }
      else {
        this.setVoucherFieldCurrencyId(voucherDto, voucherDto.currency);
      }
    }
  }

  private setVoucherFieldCurrencyId(voucherDto: VoucherViewDto, currencyId: number) {
    if (currencyId) {
      var currency: CurrencyDto = this.currencies.find(c => c.id == currencyId);
      if (!currency && voucherDto.currency) {
        currency = this.currencies.find(c => c.id == voucherDto.currency);
      }
      voucherDto.currency = currency ? currency.id : null;
      this.checkCurrrencyIsoForm(voucherDto.currencyISO, currency?.num);
      voucherDto.currencyISO = currency ? currency.num : null;
      voucherDto.currencyName = currency ? currency.name : null;
      this.voucherGridEditFormInputElementSetValue('currency', voucherDto.currencyISO, voucherDto.currency);
    }
  }

  private validateFieldCurrency(currency: string, voucherDto: VoucherViewDto): boolean {
    var ok: boolean = true;
    if (voucherDto.currencyISO != currency) {
      this.ui.info("Valuta på kreditor '" + currency + "' matcher ikke valuta på bilag '" + voucherDto.currencyISO + "'");
      ok = false;
    }
    return ok;
  }

  // Misc ----------------------------------
  private getSelectedVoucher(): VoucherViewDto {
    var dto: VoucherViewDto = null;

    // Use first selected row
    var firstRow = this.voucherGrid.getSelectedRows()[0];
    // If none selected use first row
    if (!firstRow && this.voucherGrid.getDataRows().length > 0) {
      firstRow = this.voucherGrid.getDataRows()[0];
    }
    if (firstRow) {
      var gridRow = this.voucherGrid.getRowObjectFromUID(firstRow.getAttribute('data-uid'));
      if (gridRow) {
        dto = <VoucherViewDto>gridRow.data;
      }
    }
    return dto;
  }

  private splitterResize(addPx: number) {
    if (this.attachmentsIsActive) {
      var size: string = this.splitterObj.paneSettings[1].size;
      var sizeNum: number = Number(size.substring(0, size.length - 2)) + addPx;
      size = sizeNum + 'px';
      this.splitterObj.paneSettings[1].size = size;
      if (this.tabAttachments) {
        this.tabAttachments.resize();
      }
    }
  }

  protected onSplitterResizing(args: any) {
    this.attachmentsIsActive = true;
    if (this.tabAttachments) {
      this.tabAttachments.resize();
    }
  }

  protected onSplitterExpanded(args: any) {
    this.attachmentsIsActive = true;
    if (this.tabAttachments) {
      this.tabAttachments.resize();
    }
  }

  private attachmentsShowHide() {
    if (this.splitterObj != null) {
      if (this.attachmentsIsActive && this.splitterObj.paneSettings[1].collapsed) {
        this.splitterObj.expand(1);
      }
      else {
        this.attachmentsIsActive = !this.attachmentsIsActive;
        if (this.attachmentsIsActive) {
          this.splitterObj.expand(1);
        }
        else {
          this.splitterObj.collapse(1)
        }
      }
    }
    else {
      this.attachmentsIsActive = !this.attachmentsIsActive;
    }
    if (this.attachmentsIsActive && this.detailsVm == null && this.messageGrid.getRows().length > 0) {
      this.messageGrid.selectRow(0);
    }
  }

  public onFileViewerEvent(event: ViewCommandEvent) {
    if (event == 'close') {
      this.attachmentsShowHide();
    }
    else {
      if (this.detailsVm != null) {
        var id: number = this.detailsVm.voucherMessageViewDto.id
        this.detailsVmMap.delete(id);
        this.detailsVmDataBind();
      }
    }
  }

  public onAttachmentCheckBoxApply(data: TabSelectedApplyData) {
    var id: number = this.detailsVm?.voucherMessageViewDto?.id;
    if (id != null) {
      var callback = () => {
        this.detailsVmMap.delete(id);
        this.detailsVmDataBind();
      }
      VoucherAttachmentService.messageAttachmentsApply(data, callback, this.messageClient, this.ui);
    }
  }

  // Action handling
  protected actionRun(action: ActionType, ignoreDisabledClass: boolean = false) {
    if (!this.canEdit) {
      if (action == 'Close') {
        this.actionComplete(action);
      }
      return;
    }
    if (this.actionDisabledClass && !ignoreDisabledClass) {
      return;
    }
    this.actionDoRun(action);
  }

  private actionDeferred: ActionType = null;
  protected actionSetDeferred(action: ActionType) {
    this.actionDeferred = action;
    if (!action) {
      this.actionDisabledClass = '';
    }
  }

  protected actionRunDeferred() {
    if (this.actionDeferred) {
      var action: ActionType = this.actionDeferred;
      this.actionDeferred = null;
      this.actionDoRun(action);
    }
  }

  protected actionDisabledClass: string = '';
  private actionDoRun(action: ActionType) {
    this.actionDisabledClass = "button-disabled-class";

    if (this.actionPrepareSave(action)) {
      this.actionValidate(action)
        .then(() => {
          this.actionExecute(action)
            .then(() => this.actionComplete(action))
            .catch(() => this.actionComplete('Error'))
        })
        .catch(() => this.actionComplete('Error'));
    }
    else {
      this.actionSetDeferred(action);
    }
  }

  protected actionPrepareSave(action: ActionType): boolean {
    var forceCancelEdit: boolean = (action == 'Close');
    var skipCancelUi: boolean = true;

    var isSaving = false;
    if (this.postingGrid?.isEdit == true) {
      if (this.gridEditSaveCancel(this.postingGrid, forceCancelEdit, skipCancelUi)) {
        isSaving = true;
      }
    }
    else if (this.voucherGrid?.isEdit == true) {
      if (this.gridEditSaveCancel(this.voucherGrid, forceCancelEdit, skipCancelUi)) {
        isSaving = true;
      }
    }
    return !isSaving;
  }

  protected actionExecute(action: ActionType): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.detailsVm?.voucherViewDtoList == null || this.detailsVm.voucherViewDtoList.length == 0) {
        if (action == 'Close') {
          resolve();
        }
        else {
          reject();
        }
      }
      var voucherDto: VoucherViewDto = this.detailsVm.voucherViewDtoList[0];
      switch (action) {
        case 'Close':
        case 'SaveAndClose':
          if (this.isProformaEditFromInbox && this.voucherDtoList != null && this.voucherDtoList.length > 0) {
            this.apiVoucherDeletePromise(this.voucherDtoList[0])
              .then(() => resolve())
              .catch(() => reject());
          }
          else {
            resolve();
          }
          break;
        case 'ApprovedAndClose':
          if (this.voucherCanApprove && voucherDto != null) {
            this.setApprovalStatusPromise(voucherDto.id, VoucherApprovalStatusEnum.Approved)
              .then(() => resolve())
              .catch(() => reject());
          }
          else {
            this.actionComplete(action);
          }
          break;
        case 'PendingApprovalAndClose':
          if (this.canSendToPending && voucherDto) {
            if (voucherDto.approver == null) {
              this.setNewApproverPromise(voucherDto)
                .then(detailsVm => {
                  this.setApprovalStatusPromise(voucherDto.id, VoucherApprovalStatusEnum.Pending)
                    .then(() => resolve())
                    .catch(() => reject());
                })
                .catch(() => reject());
            }
            else {
              this.setApprovalStatusPromise(voucherDto.id, VoucherApprovalStatusEnum.Pending)
                .then(() => resolve())
                .catch(() => reject());
            }
          }
          else {
            this.actionComplete(action);
          }
          break;
        case 'NewApproverAndClose':
          if (this.canNewApprover && voucherDto) {
            this.setNewApproverPromise(voucherDto)
              .then(detailsVm => {
                this.setApprovalStatusPromise(voucherDto.id, VoucherApprovalStatusEnum.Pending)
                  .then(() => resolve())
                  .catch(() => reject());
              })
              .catch(() => reject());
          }
          else {
            resolve();
          }
          break;
        case 'OnHoldAndClose':
          if (this.voucherCanHold && voucherDto != null) {
            this.setApprovalStatusPromise(voucherDto.id, VoucherApprovalStatusEnum.OnHold)
              .then(() => resolve())
              .catch(() => reject());
          }
          break;
        case 'AdjustAmounts':
          this.postingAdjustAmountsApi()
            .then(() => resolve())
            .catch(() => reject());
          break;
      }
    });
  }

  protected actionComplete(action: ActionType) {
    this.actionDisabledClass = "";
    this.actionSetDeferred(null);
    if (action != 'AdjustAmounts' && action != 'Error') {
      this.dialogRef.close({ needRefresh: true });
    }
  }

  private actionValidate(action: ActionType): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      switch (action) {
        case 'PendingApprovalAndClose':
          var voucherDto: VoucherViewDto = this.detailsVm.voucherViewDtoList[0];
          this.voucherValidateAmountPromise(action, voucherDto)
            .then(() =>
              resolve()
            )
            .catch(() =>
              reject()
            );
          break;
        default:
          resolve();
          break;
      }
    });
  }

  private voucherValidateAmountPromise(action: ActionType, voucherDto: VoucherViewDto): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (voucherDto?.amountCur != null && voucherDto?.amountCur != 0) {
        resolve();
      }
      else {
        this.ui.confirm("Beløb er ikke angivet. Send stadig til godkendelse?").then(result => {
          if (result == 'ok') {
            resolve();
          }
          else {
            reject();
          }
        });
      }
    });
  }

  private setNewApproverPromise(voucherDto: VoucherViewDto): Promise<DetailsVm> {
    return new Promise<DetailsVm>((resolve, reject) => {
      this.getApproverInput(voucherDto?.approver)
        .then(newApprover => {
          if (newApprover != null) {
            if (voucherDto.approver != newApprover) {
              voucherDto.approver = newApprover;
              this.apiVoucherPutPromise(voucherDto).then(detailsVm => {
                resolve(detailsVm);
              });
            }
            else {
              resolve(this.detailsVm);
            }
          }
          else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  private getApproverInput(valueNumber: number, title: string = 'Angiv godkender', label: string = 'Godkender', placeholder: string = 'Angiv godkender', approversNextOption: number[] = null): Promise<number> {
    return new Promise<number>((resolve, reject) => {
      var usersData = approversNextOption?.length > 0 ? this.users.filter(u => approversNextOption.includes(u.id)) : this.users;
      var inputs: PromptInput[] = [
        {
          label: label, id: "userId", placeholder: placeholder, valueNumber: valueNumber,
          type: 'DropDownList', dataSource: usersData, fields: { text: 'shortName', value: 'id' }, element: null
        }
      ];
      this.ui.promptInputs('', title, inputs).then(
        result => {
          if (result.action == 'ok') {
            resolve(result.inputs[0].ej2.value);
          }
          else {
            reject();
          }
        }
      );
    });
  }

  // Grid navigation -->
  private postingGridRefresh(rowIdx: number) {
    if (this.postingGrid && this.postingGrid.headerModule) {
      if (rowIdx >= 0) {
        if (this.gridDeferred == null) {
          this.gridDeferred = this.postingGrid;
          this.gridSelectRowIdxDeferred = rowIdx;
        }
      }
      this.postingGrid.refresh();
      this.voucherGrid.refresh();
    }
  }

  private postingGridStartEdit(forceEdit: boolean = false) {
    if (this.postingGrid) {
      var idx: number = this.gridSelectRowIdxDeferred;
      this.gridSelectRowIdxDeferred = -1;

      if (idx > -1 && idx < this.postingGrid.getRows().length) {
        this.postingGrid.selectRow(idx); // Calls recursive using onRowSelected
      }
      else if (this.postingGrid.getSelectedRows().length > 0 && !this.postingGrid.isEdit && this.postingGrid.editSettings.allowEditing) {
        this.postingGrid.startEdit();
        this.postingGrid.focusModule.focus();
      }
    }
  }

  // Vendor create (from DDL)
  private voucherCreateAccountDialog(postingType: VoucherPostingTypeEnum) {
      return new Promise<any>((resolve, reject) => {
        if (postingType == VoucherPostingTypeEnum.Vendor) {
          var data: any = {
            voucher: this.voucherDtoActive, 
            insertOnLoad: true
          };
          var config = this.ui.matDialogConfigFullScreen(data);
          this.ui.showDialogComponent(ForfatterComponent, config).then(
          result => {
            resolve(result);
          },
          error => {
            this.ui.errorToast('Fejl ved dialog visning: ', error);
            reject(error);
          });
        }
        else {
          reject('Ikke vendor posting type');
        }
    });
  }

  // Grid navigation <--
  // Grid edit complete
  /*
    /*
    private voucherGridMove(isDown: boolean) {
      var rowIdx: number = this.voucherGrid.selectedRowIndex;
      if (isDown) {
        var maxIdx: number = this.postingGrid.getRows().length - 1;
        if (rowIdx < maxIdx) {
          this.postingGrid.selectedRowIndex = rowIdx + 1;
          this.postingGrid.startEdit();
        }
        else {
          maxIdx = this.postingGrid.getRows().length - 1;
          if (maxIdx >= 0) {
            this.voucherGrid.selectedRowIndex = 0;
            this.voucherGrid.startEdit();
          }
        }
      }
      else if (this.voucherGrid.selectedRowIndex > 0) {
        this.voucherGrid.selectedRowIndex = this.voucherGrid.selectedRowIndex - 1;
      }
    }

  voucherGridChange(args) {
    console.log(args);
    let gridElement = document.getElementsByClassName('e-grid')[1] as any;
    if (gridElement != null) {
      let gridObj = gridElement.ej2_instances[0]; //get gridobj
      var selRow0 = <Element>gridObj.getSelectedRows()[0];
      if (selRow0) {
        var gridRow = this.voucherGrid.getRowObjectFromUID(selRow0.getAttribute('data-uid'));
        // refresh related data based
        //var kDto = <HovedkontraktViewDto> gridRow.data;
        //var fDto = <ForfatterDto> args.itemData;
        //kDto.agent = fDto.id;
        //kDto.agentId = fDto.forfatterId;
        //kDto.agentNavn = fDto.navn;
      }
    }
  }
  */

  /*
if (this.voucherGridRequestEditIdx != -1) {
  this.voucherGridStartEdit();
}
else if (this.postingGridRequestEditIdx != -1) {
  this.postingGridStartEdit());
}
*/

  //    this.messageGrid.refresh();

  //this.voucherGrid.refresh();
  //if (this.voucherDtoList.length > 0) {
  //this.voucherGrid.selectRow(0);
  // this.voucherGrid.beginEdit();
  //

  //this.postingGrid.refresh();

} // End component



/*
function convertDateToUTC(date: Date) {
  if (date != null) {
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  }
  return date;
}
*/
